import Client from "@/utils/Client";
import superagent from "superagent";
import {Request} from "superagent";
import moment from 'moment-timezone';

import EventBus from "@/utils/EventBus";
import RpcBase from "@/utils/RpcBase";
import Log from "@/utils/Log";
const he = require('he');


import RpcClientInternalException from "../server/com/silkplm/engine/rpc/exceptions/RpcClientInternalException.js";
import RpcException from "../server/com/silkplm/engine/rpc/exceptions/RpcException.js";
import RpcInputException from "../server/com/silkplm/engine/rpc/exceptions/RpcInputException.js";
import RpcInputValidationException from "../server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.js";
import RpcInternalException from "../server/com/silkplm/engine/rpc/exceptions/RpcInternalException.js";
import RpcLimitsExceeded from "../server/com/silkplm/engine/rpc/exceptions/RpcLimitsExceeded.js";
import RpcLoginRequired from "../server/com/silkplm/engine/rpc/exceptions/RpcLoginRequired.js";
import RpcNoPermissionsException from "../server/com/silkplm/engine/rpc/exceptions/RpcNoPermissionsException.js";
import RpcNotFoundException from "../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";
import RpcServerInternalException from "../server/com/silkplm/engine/rpc/exceptions/RpcServerInternalException.js";
import RpcUnauthorizedException from "../server/com/silkplm/engine/rpc/exceptions/RpcUnauthorizedException.js";
import RpcMustWaitException from "../server/com/silkplm/rpc/RpcMustWaitException.js";
import FileImportException from "../server/com/silkplm/rpc/exceptions/FileImportException.js";
import InvalidTaxIDException from "../server/com/silkplm/rpc/exceptions/InvalidTaxIDException.js";
import LastOwnerCannotBeDeletedException from "../server/com/silkplm/rpc/exceptions/LastOwnerCannotBeDeletedException.js";
import NoOwnerException from "../server/com/silkplm/rpc/exceptions/NoOwnerException.js";
import OrganizationDeletedException from "../server/com/silkplm/rpc/exceptions/OrganizationDeletedException.js";
import RelatedRecordsException from "../server/com/silkplm/rpc/exceptions/RelatedRecordsException.js";
import RoleIsAssignedException from "../server/com/silkplm/rpc/exceptions/RoleIsAssignedException.js";
import RoleIsNotAvailableException from "../server/com/silkplm/rpc/exceptions/RoleIsNotAvailableException.js";
import TaskBrakeException from "../server/com/silkplm/rpc/exceptions/TaskBrakeException.js";
import TooManyUsersException from "../server/com/silkplm/rpc/exceptions/TooManyUsersException.js";
import UserCannotBeDeletedException from "../server/com/silkplm/rpc/exceptions/UserCannotBeDeletedException.js";
import RpcFruitsException from "../server/com/silkplm/rpc/healthcheck/RpcFruitsException.js";
import BusinessException from "../server/com/silkplm/rpc/healthcheck/methods/BusinessException.js";
import CategoryAttributeEventChange from "../server/com/silkplm/push/CategoryAttributeEventChange.js";
import DelayedTaskComplete from "../server/com/silkplm/push/DelayedTaskComplete.js";
import DictionaryChange from "../server/com/silkplm/push/DictionaryChange.js";
import DomainVerificationChanged from "../server/com/silkplm/push/DomainVerificationChanged.js";
import DynamicAttributeEventChange from "../server/com/silkplm/push/DynamicAttributeEventChange.js";
import DynamicColumnEventChange from "../server/com/silkplm/push/DynamicColumnEventChange.js";
import DynamicDictionaryEventChange from "../server/com/silkplm/push/DynamicDictionaryEventChange.js";
import DynamicEntityChange from "../server/com/silkplm/push/DynamicEntityChange.js";
import DynamicEntityEventChange from "../server/com/silkplm/push/DynamicEntityEventChange.js";
import FormsChange from "../server/com/silkplm/push/FormsChange.js";
import NewBackgroundTaskEvent from "../server/com/silkplm/push/NewBackgroundTaskEvent.js";
import NewDocumentEvent from "../server/com/silkplm/push/NewDocumentEvent.js";
import NewInquiryMessageEvent from "../server/com/silkplm/push/NewInquiryMessageEvent.js";
import NewInspirationMessageEvent from "../server/com/silkplm/push/NewInspirationMessageEvent.js";
import NewNotification from "../server/com/silkplm/push/NewNotification.js";
import NewSupplierMessageEvent from "../server/com/silkplm/push/NewSupplierMessageEvent.js";
import ObservableEntityChange from "../server/com/silkplm/push/ObservableEntityChange.js";
import PermissionsChanged from "../server/com/silkplm/push/PermissionsChanged.js";
import PrestaShopIntegrationSentEvent from "../server/com/silkplm/push/PrestaShopIntegrationSentEvent.js";
import ProgressInfo from "../server/com/silkplm/push/ProgressInfo.js";
import PushHealthcheckEvent from "../server/com/silkplm/push/PushHealthcheckEvent.js";
import RefreshList from "../server/com/silkplm/push/RefreshList.js";
import SessionChanged from "../server/com/silkplm/push/SessionChanged.js";
import SessionTerminated from "../server/com/silkplm/push/SessionTerminated.js";
import SessionTimeout from "../server/com/silkplm/push/SessionTimeout.js";
import ShutdownMessage from "../server/com/silkplm/push/ShutdownMessage.js";
import SubiektIntegrationSentEvent from "../server/com/silkplm/push/SubiektIntegrationSentEvent.js";
import SubscribedMessage from "../server/com/silkplm/push/SubscribedMessage.js";
import SubscriptionStatusChanged from "../server/com/silkplm/push/SubscriptionStatusChanged.js";

import LocalDate from "../server/LocalDate.js";
import LocalDateTime from "../server/LocalDateTime.js";
import LocalTime from "../server/LocalTime.js";

const deduplicationLimit = 5;

export let classMap = null;

let warnedMissingTypes = {};

/**
 * @param {Promise} toExtend
 * @param {ExtendedPromise?} extended
 * @return {ExtendedPromise}
 */
export function extendPromise(toExtend, extended){
    toExtend.onProgress = function(callback){
        extended?.onProgress(callback);
    }

    toExtend.lock = function(){
        extended?.lock();
    }
    return toExtend;
}

export class ExtendedPromise extends Promise{
    /**
     * @param {function} callback
     */
    onProgress(callback){
    }
    lock(){
    }
    tag(clientTag){
    }
}

async function getClassMap(){
    if(classMap != null) {
        return classMap;
    }
    classMap = {};

    classMap["com.silkplm.push.CategoryAttributeEventChange"] =  CategoryAttributeEventChange;
    classMap["com.silkplm.push.DelayedTaskComplete"] =  DelayedTaskComplete;
    classMap["com.silkplm.push.DictionaryChange"] =  DictionaryChange;
    classMap["com.silkplm.push.DomainVerificationChanged"] =  DomainVerificationChanged;
    classMap["com.silkplm.push.DynamicAttributeEventChange"] =  DynamicAttributeEventChange;
    classMap["com.silkplm.push.DynamicColumnEventChange"] =  DynamicColumnEventChange;
    classMap["com.silkplm.push.DynamicDictionaryEventChange"] =  DynamicDictionaryEventChange;
    classMap["com.silkplm.push.DynamicEntityChange"] =  DynamicEntityChange;
    classMap["com.silkplm.push.DynamicEntityEventChange"] =  DynamicEntityEventChange;
    classMap["com.silkplm.push.FormsChange"] =  FormsChange;
    classMap["com.silkplm.push.NewBackgroundTaskEvent"] =  NewBackgroundTaskEvent;
    classMap["com.silkplm.push.NewDocumentEvent"] =  NewDocumentEvent;
    classMap["com.silkplm.push.NewInquiryMessageEvent"] =  NewInquiryMessageEvent;
    classMap["com.silkplm.push.NewInspirationMessageEvent"] =  NewInspirationMessageEvent;
    classMap["com.silkplm.push.NewNotification"] =  NewNotification;
    classMap["com.silkplm.push.NewSupplierMessageEvent"] =  NewSupplierMessageEvent;
    classMap["com.silkplm.push.ObservableEntityChange"] =  ObservableEntityChange;
    classMap["com.silkplm.push.PermissionsChanged"] =  PermissionsChanged;
    classMap["com.silkplm.push.PrestaShopIntegrationSentEvent"] =  PrestaShopIntegrationSentEvent;
    classMap["com.silkplm.push.ProgressInfo"] =  ProgressInfo;
    classMap["com.silkplm.push.PushHealthcheckEvent"] =  PushHealthcheckEvent;
    classMap["com.silkplm.push.RefreshList"] =  RefreshList;
    classMap["com.silkplm.push.SessionChanged"] =  SessionChanged;
    classMap["com.silkplm.push.SessionTerminated"] =  SessionTerminated;
    classMap["com.silkplm.push.SessionTimeout"] =  SessionTimeout;
    classMap["com.silkplm.push.ShutdownMessage"] =  ShutdownMessage;
    classMap["com.silkplm.push.SubiektIntegrationSentEvent"] =  SubiektIntegrationSentEvent;
    classMap["com.silkplm.push.SubscribedMessage"] =  SubscribedMessage;
    classMap["com.silkplm.push.SubscriptionStatusChanged"] =  SubscriptionStatusChanged;
    classMap["com.silkplm.engine.rpc.exceptions.RpcClientInternalException"] =  RpcClientInternalException;
    classMap["com.silkplm.engine.rpc.exceptions.RpcException"] =  RpcException;
    classMap["com.silkplm.engine.rpc.exceptions.RpcInputException"] =  RpcInputException;
    classMap["com.silkplm.engine.rpc.exceptions.RpcInputValidationException"] =  RpcInputValidationException;
    classMap["com.silkplm.engine.rpc.exceptions.RpcInternalException"] =  RpcInternalException;
    classMap["com.silkplm.engine.rpc.exceptions.RpcLimitsExceeded"] =  RpcLimitsExceeded;
    classMap["com.silkplm.engine.rpc.exceptions.RpcLoginRequired"] =  RpcLoginRequired;
    classMap["com.silkplm.engine.rpc.exceptions.RpcNoPermissionsException"] =  RpcNoPermissionsException;
    classMap["com.silkplm.engine.rpc.exceptions.RpcNotFoundException"] =  RpcNotFoundException;
    classMap["com.silkplm.engine.rpc.exceptions.RpcServerInternalException"] =  RpcServerInternalException;
    classMap["com.silkplm.engine.rpc.exceptions.RpcUnauthorizedException"] =  RpcUnauthorizedException;
    classMap["com.silkplm.rpc.RpcMustWaitException"] =  RpcMustWaitException;
    classMap["com.silkplm.rpc.exceptions.FileImportException"] =  FileImportException;
    classMap["com.silkplm.rpc.exceptions.InvalidTaxIDException"] =  InvalidTaxIDException;
    classMap["com.silkplm.rpc.exceptions.LastOwnerCannotBeDeletedException"] =  LastOwnerCannotBeDeletedException;
    classMap["com.silkplm.rpc.exceptions.NoOwnerException"] =  NoOwnerException;
    classMap["com.silkplm.rpc.exceptions.OrganizationDeletedException"] =  OrganizationDeletedException;
    classMap["com.silkplm.rpc.exceptions.RelatedRecordsException"] =  RelatedRecordsException;
    classMap["com.silkplm.rpc.exceptions.RoleIsAssignedException"] =  RoleIsAssignedException;
    classMap["com.silkplm.rpc.exceptions.RoleIsNotAvailableException"] =  RoleIsNotAvailableException;
    classMap["com.silkplm.rpc.exceptions.TaskBrakeException"] =  TaskBrakeException;
    classMap["com.silkplm.rpc.exceptions.TooManyUsersException"] =  TooManyUsersException;
    classMap["com.silkplm.rpc.exceptions.UserCannotBeDeletedException"] =  UserCannotBeDeletedException;
    classMap["com.silkplm.rpc.healthcheck.RpcFruitsException"] =  RpcFruitsException;
    classMap["com.silkplm.rpc.healthcheck.methods.BusinessException"] =  BusinessException;
    let allImports = [];
    if(!classMap.hasOwnProperty('com.fasterxml.jackson.core.TreeNode')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/fasterxml/jackson/core/TreeNode").then((module) => classMap["com.fasterxml.jackson.core.TreeNode"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.fasterxml.jackson.databind.JsonNode')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/fasterxml/jackson/databind/JsonNode").then((module) => classMap["com.fasterxml.jackson.databind.JsonNode"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.fasterxml.jackson.databind.node.ObjectNode')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/fasterxml/jackson/databind/node/ObjectNode").then((module) => classMap["com.fasterxml.jackson.databind.node.ObjectNode"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.dashlets.dto.UnreadMessageFromInquiryDashletEntry')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/dashlets/dto/UnreadMessageFromInquiryDashletEntry").then((module) => classMap["com.silkplm.dashlets.dto.UnreadMessageFromInquiryDashletEntry"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.dashlets.dto.UnreadMessageFromOffersDashletEntry')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/dashlets/dto/UnreadMessageFromOffersDashletEntry").then((module) => classMap["com.silkplm.dashlets.dto.UnreadMessageFromOffersDashletEntry"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.dashlets.dto.UnreadMessageFromPPSamplesDashletEntry')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/dashlets/dto/UnreadMessageFromPPSamplesDashletEntry").then((module) => classMap["com.silkplm.dashlets.dto.UnreadMessageFromPPSamplesDashletEntry"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.dashlets.dto.UnreadMessageFromSamplesDashletEntry')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/dashlets/dto/UnreadMessageFromSamplesDashletEntry").then((module) => classMap["com.silkplm.dashlets.dto.UnreadMessageFromSamplesDashletEntry"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.ActionCall')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/ActionCall").then((module) => classMap["com.silkplm.engine.actions.ActionCall"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.FormKeyword')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/FormKeyword").then((module) => classMap["com.silkplm.engine.actions.FormKeyword"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.FormSearchResult')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/FormSearchResult").then((module) => classMap["com.silkplm.engine.actions.FormSearchResult"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.Keyword')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/Keyword").then((module) => classMap["com.silkplm.engine.actions.Keyword"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.KeywordBase')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/KeywordBase").then((module) => classMap["com.silkplm.engine.actions.KeywordBase"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.NoKeywordText')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/NoKeywordText").then((module) => classMap["com.silkplm.engine.actions.NoKeywordText"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.QueryVariant')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/QueryVariant").then((module) => classMap["com.silkplm.engine.actions.QueryVariant"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.ScoredFormParameter')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/ScoredFormParameter").then((module) => classMap["com.silkplm.engine.actions.ScoredFormParameter"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.ScoredParameter')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/ScoredParameter").then((module) => classMap["com.silkplm.engine.actions.ScoredParameter"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.ScoredParameterBase')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/ScoredParameterBase").then((module) => classMap["com.silkplm.engine.actions.ScoredParameterBase"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.actions.Variant')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/actions/Variant").then((module) => classMap["com.silkplm.engine.actions.Variant"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.ChangeSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/ChangeSpec").then((module) => classMap["com.silkplm.engine.audit.ChangeSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.EntityChangeSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/EntityChangeSpec").then((module) => classMap["com.silkplm.engine.audit.EntityChangeSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.ParentEntityChangeSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/ParentEntityChangeSpec").then((module) => classMap["com.silkplm.engine.audit.ParentEntityChangeSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.FkAdd')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/FkAdd").then((module) => classMap["com.silkplm.engine.audit.changes.FkAdd"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.FkBaseChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/FkBaseChange").then((module) => classMap["com.silkplm.engine.audit.changes.FkBaseChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.FkChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/FkChange").then((module) => classMap["com.silkplm.engine.audit.changes.FkChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.FkDelete')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/FkDelete").then((module) => classMap["com.silkplm.engine.audit.changes.FkDelete"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.ListItemAdd')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/ListItemAdd").then((module) => classMap["com.silkplm.engine.audit.changes.ListItemAdd"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.ListItemDelete')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/ListItemDelete").then((module) => classMap["com.silkplm.engine.audit.changes.ListItemDelete"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.ListItemDuplicate')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/ListItemDuplicate").then((module) => classMap["com.silkplm.engine.audit.changes.ListItemDuplicate"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.ListItemMove')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/ListItemMove").then((module) => classMap["com.silkplm.engine.audit.changes.ListItemMove"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.MapItemAdd')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/MapItemAdd").then((module) => classMap["com.silkplm.engine.audit.changes.MapItemAdd"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.MapItemDelete')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/MapItemDelete").then((module) => classMap["com.silkplm.engine.audit.changes.MapItemDelete"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.MapItemDuplicate')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/MapItemDuplicate").then((module) => classMap["com.silkplm.engine.audit.changes.MapItemDuplicate"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.MapItemMove')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/MapItemMove").then((module) => classMap["com.silkplm.engine.audit.changes.MapItemMove"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.RecordChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/RecordChange").then((module) => classMap["com.silkplm.engine.audit.changes.RecordChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.ValueChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/ValueChange").then((module) => classMap["com.silkplm.engine.audit.changes.ValueChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.changes.ValueSetToNull')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/changes/ValueSetToNull").then((module) => classMap["com.silkplm.engine.audit.changes.ValueSetToNull"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.path.ListIndex')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/path/ListIndex").then((module) => classMap["com.silkplm.engine.audit.path.ListIndex"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.path.MapKey')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/path/MapKey").then((module) => classMap["com.silkplm.engine.audit.path.MapKey"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.path.PathElement')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/path/PathElement").then((module) => classMap["com.silkplm.engine.audit.path.PathElement"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.audit.path.Prop')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/audit/path/Prop").then((module) => classMap["com.silkplm.engine.audit.path.Prop"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.dashboards.DashletConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/dashboards/DashletConfig").then((module) => classMap["com.silkplm.engine.dashboards.DashletConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.db.model.DataEntity')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/db/model/DataEntity").then((module) => classMap["com.silkplm.engine.db.model.DataEntity"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.db.model.search.MatchType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/db/model/search/MatchType").then((module) => classMap["com.silkplm.engine.db.model.search.MatchType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.db.model.search.SearchResult')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/db/model/search/SearchResult").then((module) => classMap["com.silkplm.engine.db.model.search.SearchResult"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.db.model.search.SearchResultBase')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/db/model/search/SearchResultBase").then((module) => classMap["com.silkplm.engine.db.model.search.SearchResultBase"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.entities.BusinessRecord')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/entities/BusinessRecord").then((module) => classMap["com.silkplm.engine.entities.BusinessRecord"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.entities.DictionaryEntity')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/entities/DictionaryEntity").then((module) => classMap["com.silkplm.engine.entities.DictionaryEntity"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.entities.ObservableEntity')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/entities/ObservableEntity").then((module) => classMap["com.silkplm.engine.entities.ObservableEntity"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.entities.Supplement')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/entities/Supplement").then((module) => classMap["com.silkplm.engine.entities.Supplement"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.entities.TreeNodeSupplement')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/entities/TreeNodeSupplement").then((module) => classMap["com.silkplm.engine.entities.TreeNodeSupplement"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.entities.tracking.RecordMetadata')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/entities/tracking/RecordMetadata").then((module) => classMap["com.silkplm.engine.entities.tracking.RecordMetadata"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.files.PublicFAT')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/files/PublicFAT").then((module) => classMap["com.silkplm.engine.files.PublicFAT"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.files.UploadedFile')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/files/UploadedFile").then((module) => classMap["com.silkplm.engine.files.UploadedFile"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.files.WclAccessToken')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/files/WclAccessToken").then((module) => classMap["com.silkplm.engine.files.WclAccessToken"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.DetailStyle')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/DetailStyle").then((module) => classMap["com.silkplm.engine.forms.DetailStyle"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.BaseFormConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/BaseFormConfig").then((module) => classMap["com.silkplm.engine.forms.schema.BaseFormConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.MasterFormConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/MasterFormConfig").then((module) => classMap["com.silkplm.engine.forms.schema.MasterFormConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.ShowTreeRootOptions')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/ShowTreeRootOptions").then((module) => classMap["com.silkplm.engine.forms.schema.ShowTreeRootOptions"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.TreeConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/TreeConfig").then((module) => classMap["com.silkplm.engine.forms.schema.TreeConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.TwoLayersTemplateConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/TwoLayersTemplateConfig").then((module) => classMap["com.silkplm.engine.forms.schema.TwoLayersTemplateConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.AdvancedPermissionConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/AdvancedPermissionConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.AdvancedPermissionConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.AttachmentsFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/AttachmentsFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.AttachmentsFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.CheckboxFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/CheckboxFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.CheckboxFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.ClassWatch')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/ClassWatch").then((module) => classMap["com.silkplm.engine.forms.schema.definition.ClassWatch"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.ColorPickerFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/ColorPickerFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.ColorPickerFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.ComputedLink')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/ComputedLink").then((module) => classMap["com.silkplm.engine.forms.schema.definition.ComputedLink"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.DateFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/DateFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.DateFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.DecimalFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/DecimalFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.DecimalFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.DynamicFormConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/DynamicFormConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.DynamicFormConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.DynamicValueFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/DynamicValueFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.DynamicValueFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.ExtendedConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/ExtendedConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.ExtendedConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.FieldCloneOptionsConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/FieldCloneOptionsConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.FieldCloneOptionsConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.FormConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/FormConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.FormConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.FormDetailsConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/FormDetailsConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.FormDetailsConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.FormExtensionConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/FormExtensionConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.FormExtensionConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.FormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/FormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.FormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.FormShadowFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/FormShadowFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.FormShadowFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.GalleryFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/GalleryFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.GalleryFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.HiddenFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/HiddenFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.HiddenFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.ImageFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/ImageFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.ImageFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.IntFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/IntFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.IntFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.ListFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/ListFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.ListFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.MixinFormComponentConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/MixinFormComponentConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.MixinFormComponentConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.SelectFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/SelectFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.SelectFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.TextFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/TextFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.TextFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.TextListFormFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/TextListFormFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.TextListFormFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.fields.SecuredFieldConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/fields/SecuredFieldConfig").then((module) => classMap["com.silkplm.engine.forms.schema.definition.fields.SecuredFieldConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.filters.CheckBoxFilterSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/filters/CheckBoxFilterSpec").then((module) => classMap["com.silkplm.engine.forms.schema.definition.filters.CheckBoxFilterSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.filters.DateFilterSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/filters/DateFilterSpec").then((module) => classMap["com.silkplm.engine.forms.schema.definition.filters.DateFilterSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.filters.IdFilterSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/filters/IdFilterSpec").then((module) => classMap["com.silkplm.engine.forms.schema.definition.filters.IdFilterSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.filters.NumericFilterSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/filters/NumericFilterSpec").then((module) => classMap["com.silkplm.engine.forms.schema.definition.filters.NumericFilterSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.filters.SelectFilterSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/filters/SelectFilterSpec").then((module) => classMap["com.silkplm.engine.forms.schema.definition.filters.SelectFilterSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.schema.definition.filters.TextFilterSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/schema/definition/filters/TextFilterSpec").then((module) => classMap["com.silkplm.engine.forms.schema.definition.filters.TextFilterSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.views.FormViewConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/views/FormViewConfig").then((module) => classMap["com.silkplm.engine.forms.views.FormViewConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.forms.views.ViewMemberClass')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/forms/views/ViewMemberClass").then((module) => classMap["com.silkplm.engine.forms.views.ViewMemberClass"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.json.JsonData')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/json/JsonData").then((module) => classMap["com.silkplm.engine.json.JsonData"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.knowledge.base.Country')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/knowledge/base/Country").then((module) => classMap["com.silkplm.engine.knowledge.base.Country"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.knowledge.base.Currency')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/knowledge/base/Currency").then((module) => classMap["com.silkplm.engine.knowledge.base.Currency"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.model.ActionFindReport')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/model/ActionFindReport").then((module) => classMap["com.silkplm.engine.model.ActionFindReport"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.model.ActionFindReportItem')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/model/ActionFindReportItem").then((module) => classMap["com.silkplm.engine.model.ActionFindReportItem"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.model.BoardTemplate')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/model/BoardTemplate").then((module) => classMap["com.silkplm.engine.model.BoardTemplate"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.model.Dictionary')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/model/Dictionary").then((module) => classMap["com.silkplm.engine.model.Dictionary"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.model.EntityPrintoutQuery')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/model/EntityPrintoutQuery").then((module) => classMap["com.silkplm.engine.model.EntityPrintoutQuery"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.model.PrintoutTemplate')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/model/PrintoutTemplate").then((module) => classMap["com.silkplm.engine.model.PrintoutTemplate"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.model.Region')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/model/Region").then((module) => classMap["com.silkplm.engine.model.Region"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.model.bot.BotResponse')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/model/bot/BotResponse").then((module) => classMap["com.silkplm.engine.model.bot.BotResponse"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.model.bot.OutputMessage')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/model/bot/OutputMessage").then((module) => classMap["com.silkplm.engine.model.bot.OutputMessage"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.reports.XlsReportConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/reports/XlsReportConfig").then((module) => classMap["com.silkplm.engine.reports.XlsReportConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.reports.filters.ApplicationUserFilterDataModel')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/reports/filters/ApplicationUserFilterDataModel").then((module) => classMap["com.silkplm.engine.reports.filters.ApplicationUserFilterDataModel"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.reports.filters.DateFilterDataModel')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/reports/filters/DateFilterDataModel").then((module) => classMap["com.silkplm.engine.reports.filters.DateFilterDataModel"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.reports.filters.DictionaryFilterDataModel')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/reports/filters/DictionaryFilterDataModel").then((module) => classMap["com.silkplm.engine.reports.filters.DictionaryFilterDataModel"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.reports.filters.ReportFilterSpec')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/reports/filters/ReportFilterSpec").then((module) => classMap["com.silkplm.engine.reports.filters.ReportFilterSpec"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.reports.filters.TreeFilterDataModel')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/reports/filters/TreeFilterDataModel").then((module) => classMap["com.silkplm.engine.reports.filters.TreeFilterDataModel"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcClientInternalException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcClientInternalException").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcClientInternalException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcException").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcInputException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcInputException").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcInputException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcInputValidationException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcInputValidationException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcInternalException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcInternalException").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcInternalException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcLimitsExceeded')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcLimitsExceeded").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcLimitsExceeded"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcLoginRequired')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcLoginRequired").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcLoginRequired"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcNoPermissionsException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcNoPermissionsException").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcNoPermissionsException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcNotFoundException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcNotFoundException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcServerInternalException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcServerInternalException").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcServerInternalException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.exceptions.RpcUnauthorizedException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/exceptions/RpcUnauthorizedException").then((module) => classMap["com.silkplm.engine.rpc.exceptions.RpcUnauthorizedException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.validators.FieldValidationResult')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/validators/FieldValidationResult").then((module) => classMap["com.silkplm.engine.rpc.validators.FieldValidationResult"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.rpc.validators.InputValidationResult')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/rpc/validators/InputValidationResult").then((module) => classMap["com.silkplm.engine.rpc.validators.InputValidationResult"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.sso.GoogleLoginResult')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/sso/GoogleLoginResult").then((module) => classMap["com.silkplm.engine.sso.GoogleLoginResult"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.engine.translations.DetectResult')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/engine/translations/DetectResult").then((module) => classMap["com.silkplm.engine.translations.DetectResult"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.files.images.ImageGallery')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/files/images/ImageGallery").then((module) => classMap["com.silkplm.files.images.ImageGallery"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.forms.TreeElementInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/forms/TreeElementInfo").then((module) => classMap["com.silkplm.forms.TreeElementInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.labels.LabelInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/labels/LabelInfo").then((module) => classMap["com.silkplm.labels.LabelInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.labels.LabelInfoShort')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/labels/LabelInfoShort").then((module) => classMap["com.silkplm.labels.LabelInfoShort"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.TipTapTest')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/TipTapTest").then((module) => classMap["com.silkplm.model.TipTapTest"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.files.FileInRepository')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/files/FileInRepository").then((module) => classMap["com.silkplm.model.files.FileInRepository"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.Animal')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/Animal").then((module) => classMap["com.silkplm.model.healthcheck.Animal"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.AuditTestForm')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/AuditTestForm").then((module) => classMap["com.silkplm.model.healthcheck.AuditTestForm"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.BKTest')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/BKTest").then((module) => classMap["com.silkplm.model.healthcheck.BKTest"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.BookChapter')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/BookChapter").then((module) => classMap["com.silkplm.model.healthcheck.BookChapter"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.BookDigest')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/BookDigest").then((module) => classMap["com.silkplm.model.healthcheck.BookDigest"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.BookDigestDetail')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/BookDigestDetail").then((module) => classMap["com.silkplm.model.healthcheck.BookDigestDetail"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.BookHealthcheck')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/BookHealthcheck").then((module) => classMap["com.silkplm.model.healthcheck.BookHealthcheck"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.BookMaterial')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/BookMaterial").then((module) => classMap["com.silkplm.model.healthcheck.BookMaterial"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.BookStatusDict')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/BookStatusDict").then((module) => classMap["com.silkplm.model.healthcheck.BookStatusDict"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.Cal')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/Cal").then((module) => classMap["com.silkplm.model.healthcheck.Cal"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.Car')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/Car").then((module) => classMap["com.silkplm.model.healthcheck.Car"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.ColorSet')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/ColorSet").then((module) => classMap["com.silkplm.model.healthcheck.ColorSet"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.DesignedModel')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/DesignedModel").then((module) => classMap["com.silkplm.model.healthcheck.DesignedModel"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.GridEditableTest')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/GridEditableTest").then((module) => classMap["com.silkplm.model.healthcheck.GridEditableTest"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.OrgChildEntity')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/OrgChildEntity").then((module) => classMap["com.silkplm.model.healthcheck.OrgChildEntity"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.OrgEntity')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/OrgEntity").then((module) => classMap["com.silkplm.model.healthcheck.OrgEntity"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.Patient')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/Patient").then((module) => classMap["com.silkplm.model.healthcheck.Patient"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SampleEntity')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SampleEntity").then((module) => classMap["com.silkplm.model.healthcheck.SampleEntity"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleDictionaryEntityForm')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleDictionaryEntityForm").then((module) => classMap["com.silkplm.model.healthcheck.SimpleDictionaryEntityForm"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleForm')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleForm").then((module) => classMap["com.silkplm.model.healthcheck.SimpleForm"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleFormChatMessage')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleFormChatMessage").then((module) => classMap["com.silkplm.model.healthcheck.SimpleFormChatMessage"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleFormChild')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleFormChild").then((module) => classMap["com.silkplm.model.healthcheck.SimpleFormChild"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleFormColorTest')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleFormColorTest").then((module) => classMap["com.silkplm.model.healthcheck.SimpleFormColorTest"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleFormDatesTest')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleFormDatesTest").then((module) => classMap["com.silkplm.model.healthcheck.SimpleFormDatesTest"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleFormExtension')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleFormExtension").then((module) => classMap["com.silkplm.model.healthcheck.SimpleFormExtension"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleFormMaster')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleFormMaster").then((module) => classMap["com.silkplm.model.healthcheck.SimpleFormMaster"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleFormSKU')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleFormSKU").then((module) => classMap["com.silkplm.model.healthcheck.SimpleFormSKU"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleFormTest')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleFormTest").then((module) => classMap["com.silkplm.model.healthcheck.SimpleFormTest"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.SimpleFormTestSelect')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/SimpleFormTestSelect").then((module) => classMap["com.silkplm.model.healthcheck.SimpleFormTestSelect"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.ValidationCase')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/ValidationCase").then((module) => classMap["com.silkplm.model.healthcheck.ValidationCase"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.multifk.TestCity')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/multifk/TestCity").then((module) => classMap["com.silkplm.model.healthcheck.multifk.TestCity"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.multifk.TestShop')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/multifk/TestShop").then((module) => classMap["com.silkplm.model.healthcheck.multifk.TestShop"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.multifk.TestState')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/multifk/TestState").then((module) => classMap["com.silkplm.model.healthcheck.multifk.TestState"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.multifk.TestVilage')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/multifk/TestVilage").then((module) => classMap["com.silkplm.model.healthcheck.multifk.TestVilage"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.multifk.tree.BookCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/multifk/tree/BookCategory").then((module) => classMap["com.silkplm.model.healthcheck.multifk.tree.BookCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.refs.RefsMaster')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/refs/RefsMaster").then((module) => classMap["com.silkplm.model.healthcheck.refs.RefsMaster"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.refs.RefsMaterial')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/refs/RefsMaterial").then((module) => classMap["com.silkplm.model.healthcheck.refs.RefsMaterial"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.refs.RefsMaterialAndPercents')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/refs/RefsMaterialAndPercents").then((module) => classMap["com.silkplm.model.healthcheck.refs.RefsMaterialAndPercents"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.refs.RefsMaterialAndPercentsRestricted')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/refs/RefsMaterialAndPercentsRestricted").then((module) => classMap["com.silkplm.model.healthcheck.refs.RefsMaterialAndPercentsRestricted"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.removals.TestGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/removals/TestGroup").then((module) => classMap["com.silkplm.model.healthcheck.removals.TestGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.removals.TestItemCascadeRef')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/removals/TestItemCascadeRef").then((module) => classMap["com.silkplm.model.healthcheck.removals.TestItemCascadeRef"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.removals.TestItemNullableRef')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/removals/TestItemNullableRef").then((module) => classMap["com.silkplm.model.healthcheck.removals.TestItemNullableRef"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.removals.TestItemRestrictedRef')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/removals/TestItemRestrictedRef").then((module) => classMap["com.silkplm.model.healthcheck.removals.TestItemRestrictedRef"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.removals.TestItemTransitiveRef')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/removals/TestItemTransitiveRef").then((module) => classMap["com.silkplm.model.healthcheck.removals.TestItemTransitiveRef"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.templates.BookParentCatReviewToBook')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/templates/BookParentCatReviewToBook").then((module) => classMap["com.silkplm.model.healthcheck.templates.BookParentCatReviewToBook"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.templates.BookParentCatReviewToCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/templates/BookParentCatReviewToCategory").then((module) => classMap["com.silkplm.model.healthcheck.templates.BookParentCatReviewToCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.templates.BookReview')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/templates/BookReview").then((module) => classMap["com.silkplm.model.healthcheck.templates.BookReview"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.templates.BookReviewToBook')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/templates/BookReviewToBook").then((module) => classMap["com.silkplm.model.healthcheck.templates.BookReviewToBook"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.templates.BookReviewToCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/templates/BookReviewToCategory").then((module) => classMap["com.silkplm.model.healthcheck.templates.BookReviewToCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.templates.BookTest')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/templates/BookTest").then((module) => classMap["com.silkplm.model.healthcheck.templates.BookTest"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.healthcheck.templates.BookTestType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/healthcheck/templates/BookTestType").then((module) => classMap["com.silkplm.model.healthcheck.templates.BookTestType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.matching.MarketingMatchedProducts')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/matching/MarketingMatchedProducts").then((module) => classMap["com.silkplm.model.matching.MarketingMatchedProducts"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.matching.MarketingSimilarProducts')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/matching/MarketingSimilarProducts").then((module) => classMap["com.silkplm.model.matching.MarketingSimilarProducts"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.matching.MatchedProductsInSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/matching/MatchedProductsInSeason").then((module) => classMap["com.silkplm.model.matching.MatchedProductsInSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.matching.SimilarProductsInSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/matching/SimilarProductsInSeason").then((module) => classMap["com.silkplm.model.matching.SimilarProductsInSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.AdditionalActivity')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/AdditionalActivity").then((module) => classMap["com.silkplm.model.plm.AdditionalActivity"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.AdditionalCostCalculation')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/AdditionalCostCalculation").then((module) => classMap["com.silkplm.model.plm.AdditionalCostCalculation"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.AdditionalCostInOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/AdditionalCostInOffer").then((module) => classMap["com.silkplm.model.plm.AdditionalCostInOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.AdditionalCosts')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/AdditionalCosts").then((module) => classMap["com.silkplm.model.plm.AdditionalCosts"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.AdditionalInformationForBrandingList')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/AdditionalInformationForBrandingList").then((module) => classMap["com.silkplm.model.plm.AdditionalInformationForBrandingList"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ApplicationUserOnProduct')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ApplicationUserOnProduct").then((module) => classMap["com.silkplm.model.plm.ApplicationUserOnProduct"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ApplicationUserOnProductEmbedded')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded").then((module) => classMap["com.silkplm.model.plm.ApplicationUserOnProductEmbedded"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ApplicationUserOnProductInSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ApplicationUserOnProductInSeason").then((module) => classMap["com.silkplm.model.plm.ApplicationUserOnProductInSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ApplicationUserOnProductInSeasonEmbedded')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ApplicationUserOnProductInSeasonEmbedded").then((module) => classMap["com.silkplm.model.plm.ApplicationUserOnProductInSeasonEmbedded"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.AssignProductsToSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/AssignProductsToSeason").then((module) => classMap["com.silkplm.model.plm.AssignProductsToSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BankDetails')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BankDetails").then((module) => classMap["com.silkplm.model.plm.BankDetails"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BasicCostCalculation')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BasicCostCalculation").then((module) => classMap["com.silkplm.model.plm.BasicCostCalculation"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BasicCostInNegotiationPlanning')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BasicCostInNegotiationPlanning").then((module) => classMap["com.silkplm.model.plm.BasicCostInNegotiationPlanning"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BasicCostInOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BasicCostInOffer").then((module) => classMap["com.silkplm.model.plm.BasicCostInOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BasicCostInPlanningProduct')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BasicCostInPlanningProduct").then((module) => classMap["com.silkplm.model.plm.BasicCostInPlanningProduct"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Booking')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Booking").then((module) => classMap["com.silkplm.model.plm.Booking"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BrandingCalculation')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BrandingCalculation").then((module) => classMap["com.silkplm.model.plm.BrandingCalculation"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BrandingCalculationInOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BrandingCalculationInOffer").then((module) => classMap["com.silkplm.model.plm.BrandingCalculationInOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BrandingCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BrandingCategory").then((module) => classMap["com.silkplm.model.plm.BrandingCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BrandingParameters')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BrandingParameters").then((module) => classMap["com.silkplm.model.plm.BrandingParameters"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BrandingProduct')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BrandingProduct").then((module) => classMap["com.silkplm.model.plm.BrandingProduct"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BudgetingPlanner')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BudgetingPlanner").then((module) => classMap["com.silkplm.model.plm.BudgetingPlanner"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.BudgetingPlannerPM')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/BudgetingPlannerPM").then((module) => classMap["com.silkplm.model.plm.BudgetingPlannerPM"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Calculation')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Calculation").then((module) => classMap["com.silkplm.model.plm.Calculation"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Capsule')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Capsule").then((module) => classMap["com.silkplm.model.plm.Capsule"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Category')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Category").then((module) => classMap["com.silkplm.model.plm.Category"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.CategoryAttributes')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/CategoryAttributes").then((module) => classMap["com.silkplm.model.plm.CategoryAttributes"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Color')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Color").then((module) => classMap["com.silkplm.model.plm.Color"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ColorForProductInSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ColorForProductInSeason").then((module) => classMap["com.silkplm.model.plm.ColorForProductInSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ColorVersion')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ColorVersion").then((module) => classMap["com.silkplm.model.plm.ColorVersion"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ColorVersionBindingPlanning')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ColorVersionBindingPlanning").then((module) => classMap["com.silkplm.model.plm.ColorVersionBindingPlanning"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.CommissionGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/CommissionGroup").then((module) => classMap["com.silkplm.model.plm.CommissionGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.CompanyConfiguration')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/CompanyConfiguration").then((module) => classMap["com.silkplm.model.plm.CompanyConfiguration"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.CompanyConfigurationForm')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/CompanyConfigurationForm").then((module) => classMap["com.silkplm.model.plm.CompanyConfigurationForm"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.CompanyConfigurationFormField')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/CompanyConfigurationFormField").then((module) => classMap["com.silkplm.model.plm.CompanyConfigurationFormField"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ComponentIndexOnTranche')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ComponentIndexOnTranche").then((module) => classMap["com.silkplm.model.plm.ComponentIndexOnTranche"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ComponentIndexProductComponent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ComponentIndexProductComponent").then((module) => classMap["com.silkplm.model.plm.ComponentIndexProductComponent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ConstructionPointForDimension')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ConstructionPointForDimension").then((module) => classMap["com.silkplm.model.plm.ConstructionPointForDimension"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ConstructionPointForProductGrading')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ConstructionPointForProductGrading").then((module) => classMap["com.silkplm.model.plm.ConstructionPointForProductGrading"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Contract')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Contract").then((module) => classMap["com.silkplm.model.plm.Contract"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Delegation')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Delegation").then((module) => classMap["com.silkplm.model.plm.Delegation"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.DeliveryDateStore')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/DeliveryDateStore").then((module) => classMap["com.silkplm.model.plm.DeliveryDateStore"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Design')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Design").then((module) => classMap["com.silkplm.model.plm.Design"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.DimensionPPSample')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/DimensionPPSample").then((module) => classMap["com.silkplm.model.plm.DimensionPPSample"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Dimensions')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Dimensions").then((module) => classMap["com.silkplm.model.plm.Dimensions"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.DimensionsCells')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/DimensionsCells").then((module) => classMap["com.silkplm.model.plm.DimensionsCells"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.DimensionsColumns')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/DimensionsColumns").then((module) => classMap["com.silkplm.model.plm.DimensionsColumns"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.DimensionsRows')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/DimensionsRows").then((module) => classMap["com.silkplm.model.plm.DimensionsRows"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.DutyCostGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/DutyCostGroup").then((module) => classMap["com.silkplm.model.plm.DutyCostGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.DynamicAttributeCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/DynamicAttributeCategory").then((module) => classMap["com.silkplm.model.plm.DynamicAttributeCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.EAN')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/EAN").then((module) => classMap["com.silkplm.model.plm.EAN"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.EANForColorVersion')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/EANForColorVersion").then((module) => classMap["com.silkplm.model.plm.EANForColorVersion"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.EANForSizeInProductInSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/EANForSizeInProductInSeason").then((module) => classMap["com.silkplm.model.plm.EANForSizeInProductInSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.EANRange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/EANRange").then((module) => classMap["com.silkplm.model.plm.EANRange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ERPDetailsCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ERPDetailsCategory").then((module) => classMap["com.silkplm.model.plm.ERPDetailsCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ExchangeRates')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ExchangeRates").then((module) => classMap["com.silkplm.model.plm.ExchangeRates"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.FixedCostGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/FixedCostGroup").then((module) => classMap["com.silkplm.model.plm.FixedCostGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ForwardingCompanies')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ForwardingCompanies").then((module) => classMap["com.silkplm.model.plm.ForwardingCompanies"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ForwardingCompaniesPricesHistory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ForwardingCompaniesPricesHistory").then((module) => classMap["com.silkplm.model.plm.ForwardingCompaniesPricesHistory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.GS1')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/GS1").then((module) => classMap["com.silkplm.model.plm.GS1"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.HintInput')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/HintInput").then((module) => classMap["com.silkplm.model.plm.HintInput"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.IngredientWithValue')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/IngredientWithValue").then((module) => classMap["com.silkplm.model.plm.IngredientWithValue"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Inspiration')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Inspiration").then((module) => classMap["com.silkplm.model.plm.Inspiration"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.IntegrationLogger')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/IntegrationLogger").then((module) => classMap["com.silkplm.model.plm.IntegrationLogger"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.KeyVisualCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/KeyVisualCategory").then((module) => classMap["com.silkplm.model.plm.KeyVisualCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Line')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Line").then((module) => classMap["com.silkplm.model.plm.Line"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ListOfContractorAttribute')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ListOfContractorAttribute").then((module) => classMap["com.silkplm.model.plm.ListOfContractorAttribute"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ListOfQCAndCosts')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ListOfQCAndCosts").then((module) => classMap["com.silkplm.model.plm.ListOfQCAndCosts"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ListOfQCAndCostsOnTrancheBooking')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ListOfQCAndCostsOnTrancheBooking").then((module) => classMap["com.silkplm.model.plm.ListOfQCAndCostsOnTrancheBooking"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.LogisticsBookingStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/LogisticsBookingStatus").then((module) => classMap["com.silkplm.model.plm.LogisticsBookingStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.LogisticsBookingStatusPickupDate')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/LogisticsBookingStatusPickupDate").then((module) => classMap["com.silkplm.model.plm.LogisticsBookingStatusPickupDate"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.LogisticsBookingStatusProductionStartDate')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/LogisticsBookingStatusProductionStartDate").then((module) => classMap["com.silkplm.model.plm.LogisticsBookingStatusProductionStartDate"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.LogisticsBookingStatusShippingDate')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/LogisticsBookingStatusShippingDate").then((module) => classMap["com.silkplm.model.plm.LogisticsBookingStatusShippingDate"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.LogisticsData')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/LogisticsData").then((module) => classMap["com.silkplm.model.plm.LogisticsData"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.LogisticsDeliveryPlan')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/LogisticsDeliveryPlan").then((module) => classMap["com.silkplm.model.plm.LogisticsDeliveryPlan"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.LogisticsInquiries')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/LogisticsInquiries").then((module) => classMap["com.silkplm.model.plm.LogisticsInquiries"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.LogisticsInquiriesProposition')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/LogisticsInquiriesProposition").then((module) => classMap["com.silkplm.model.plm.LogisticsInquiriesProposition"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Marketing')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Marketing").then((module) => classMap["com.silkplm.model.plm.Marketing"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Material')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Material").then((module) => classMap["com.silkplm.model.plm.Material"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.MaterialComposition')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/MaterialComposition").then((module) => classMap["com.silkplm.model.plm.MaterialComposition"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.MaterialForProductWclElement')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/MaterialForProductWclElement").then((module) => classMap["com.silkplm.model.plm.MaterialForProductWclElement"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.MethodOfExecutionPPSamples')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/MethodOfExecutionPPSamples").then((module) => classMap["com.silkplm.model.plm.MethodOfExecutionPPSamples"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ModelComponent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ModelComponent").then((module) => classMap["com.silkplm.model.plm.ModelComponent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.MultiSelectToProductInSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/MultiSelectToProductInSeason").then((module) => classMap["com.silkplm.model.plm.MultiSelectToProductInSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.NegotiationPlanning')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/NegotiationPlanning").then((module) => classMap["com.silkplm.model.plm.NegotiationPlanning"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Order')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Order").then((module) => classMap["com.silkplm.model.plm.Order"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OrderDetails')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OrderDetails").then((module) => classMap["com.silkplm.model.plm.OrderDetails"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OrderDetailsIntegrationView')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OrderDetailsIntegrationView").then((module) => classMap["com.silkplm.model.plm.OrderDetailsIntegrationView"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OrderDetailsPackageCell')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OrderDetailsPackageCell").then((module) => classMap["com.silkplm.model.plm.OrderDetailsPackageCell"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OrderDetailsPackageColumn')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OrderDetailsPackageColumn").then((module) => classMap["com.silkplm.model.plm.OrderDetailsPackageColumn"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OrderDetailsPackageRow')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OrderDetailsPackageRow").then((module) => classMap["com.silkplm.model.plm.OrderDetailsPackageRow"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OrderDetailsViewIntegrationLoggerInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OrderDetailsViewIntegrationLoggerInfo").then((module) => classMap["com.silkplm.model.plm.OrderDetailsViewIntegrationLoggerInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OrderIntegrationView')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OrderIntegrationView").then((module) => classMap["com.silkplm.model.plm.OrderIntegrationView"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OrderIntegrationViewIntegrationLoggerInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OrderIntegrationViewIntegrationLoggerInfo").then((module) => classMap["com.silkplm.model.plm.OrderIntegrationViewIntegrationLoggerInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OrganizationFormsSettings')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OrganizationFormsSettings").then((module) => classMap["com.silkplm.model.plm.OrganizationFormsSettings"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OtherCostCalculation')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OtherCostCalculation").then((module) => classMap["com.silkplm.model.plm.OtherCostCalculation"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.OtherCostInOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/OtherCostInOffer").then((module) => classMap["com.silkplm.model.plm.OtherCostInOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.PPSampleDecision')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/PPSampleDecision").then((module) => classMap["com.silkplm.model.plm.PPSampleDecision"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.PPSampleInquiry')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/PPSampleInquiry").then((module) => classMap["com.silkplm.model.plm.PPSampleInquiry"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.PPSamplesProduct')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/PPSamplesProduct").then((module) => classMap["com.silkplm.model.plm.PPSamplesProduct"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.PPSamplesProductDetails')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/PPSamplesProductDetails").then((module) => classMap["com.silkplm.model.plm.PPSamplesProductDetails"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.PackagingProduct')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/PackagingProduct").then((module) => classMap["com.silkplm.model.plm.PackagingProduct"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.PlanningProduct')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/PlanningProduct").then((module) => classMap["com.silkplm.model.plm.PlanningProduct"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.PrestaShop')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/PrestaShop").then((module) => classMap["com.silkplm.model.plm.PrestaShop"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Product')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Product").then((module) => classMap["com.silkplm.model.plm.Product"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductAttributes')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductAttributes").then((module) => classMap["com.silkplm.model.plm.ProductAttributes"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductComponentCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductComponentCategory").then((module) => classMap["com.silkplm.model.plm.ProductComponentCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductInSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductInSeason").then((module) => classMap["com.silkplm.model.plm.ProductInSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductInSeasonCells')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductInSeasonCells").then((module) => classMap["com.silkplm.model.plm.ProductInSeasonCells"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductInSeasonColumns')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductInSeasonColumns").then((module) => classMap["com.silkplm.model.plm.ProductInSeasonColumns"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductInquiry')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductInquiry").then((module) => classMap["com.silkplm.model.plm.ProductInquiry"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductIntegrationView')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductIntegrationView").then((module) => classMap["com.silkplm.model.plm.ProductIntegrationView"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductOnDeliveryPlan')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductOnDeliveryPlan").then((module) => classMap["com.silkplm.model.plm.ProductOnDeliveryPlan"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductOnTranche')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductOnTranche").then((module) => classMap["com.silkplm.model.plm.ProductOnTranche"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductViewIntegrationLogger')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductViewIntegrationLogger").then((module) => classMap["com.silkplm.model.plm.ProductViewIntegrationLogger"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductWCLElements')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductWCLElements").then((module) => classMap["com.silkplm.model.plm.ProductWCLElements"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ProductsList')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ProductsList").then((module) => classMap["com.silkplm.model.plm.ProductsList"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.QualityControlAndAdditionalCosts')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/QualityControlAndAdditionalCosts").then((module) => classMap["com.silkplm.model.plm.QualityControlAndAdditionalCosts"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Remark')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Remark").then((module) => classMap["com.silkplm.model.plm.Remark"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Representative')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Representative").then((module) => classMap["com.silkplm.model.plm.Representative"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.RequiredTestProduct')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/RequiredTestProduct").then((module) => classMap["com.silkplm.model.plm.RequiredTestProduct"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.RequiredTestProductCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/RequiredTestProductCategory").then((module) => classMap["com.silkplm.model.plm.RequiredTestProductCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.RequiredTestProductStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/RequiredTestProductStatus").then((module) => classMap["com.silkplm.model.plm.RequiredTestProductStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.RequiredTestReport')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/RequiredTestReport").then((module) => classMap["com.silkplm.model.plm.RequiredTestReport"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.SampleCostGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/SampleCostGroup").then((module) => classMap["com.silkplm.model.plm.SampleCostGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Season')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Season").then((module) => classMap["com.silkplm.model.plm.Season"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ShipmentSample')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ShipmentSample").then((module) => classMap["com.silkplm.model.plm.ShipmentSample"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ShipmentStatusWithQuantity')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ShipmentStatusWithQuantity").then((module) => classMap["com.silkplm.model.plm.ShipmentStatusWithQuantity"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.SizeForPpSample')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/SizeForPpSample").then((module) => classMap["com.silkplm.model.plm.SizeForPpSample"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.SizeForProductGrading')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/SizeForProductGrading").then((module) => classMap["com.silkplm.model.plm.SizeForProductGrading"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.SizeForProductInSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/SizeForProductInSeason").then((module) => classMap["com.silkplm.model.plm.SizeForProductInSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.SizeInProductInSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/SizeInProductInSeason").then((module) => classMap["com.silkplm.model.plm.SizeInProductInSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.SizeRangeForPpSample')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/SizeRangeForPpSample").then((module) => classMap["com.silkplm.model.plm.SizeRangeForPpSample"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.SizesInSizeRanges')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/SizesInSizeRanges").then((module) => classMap["com.silkplm.model.plm.SizesInSizeRanges"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.SizesPercentageBreakdownDetails')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/SizesPercentageBreakdownDetails").then((module) => classMap["com.silkplm.model.plm.SizesPercentageBreakdownDetails"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.SubSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/SubSeason").then((module) => classMap["com.silkplm.model.plm.SubSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Suppliers')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Suppliers").then((module) => classMap["com.silkplm.model.plm.Suppliers"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.TechnologicalDetailsWashAndMaintenance')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/TechnologicalDetailsWashAndMaintenance").then((module) => classMap["com.silkplm.model.plm.TechnologicalDetailsWashAndMaintenance"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Tranche')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Tranche").then((module) => classMap["com.silkplm.model.plm.Tranche"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.TrancheBooking')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/TrancheBooking").then((module) => classMap["com.silkplm.model.plm.TrancheBooking"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.TrancheBookingAdditionalCosts')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/TrancheBookingAdditionalCosts").then((module) => classMap["com.silkplm.model.plm.TrancheBookingAdditionalCosts"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.TrancheBookingDetails')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/TrancheBookingDetails").then((module) => classMap["com.silkplm.model.plm.TrancheBookingDetails"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.TranchePlanView')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/TranchePlanView").then((module) => classMap["com.silkplm.model.plm.TranchePlanView"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.TransportCostGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/TransportCostGroup").then((module) => classMap["com.silkplm.model.plm.TransportCostGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.UpgradeOptions')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/UpgradeOptions").then((module) => classMap["com.silkplm.model.plm.UpgradeOptions"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.UserOnWishlist')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/UserOnWishlist").then((module) => classMap["com.silkplm.model.plm.UserOnWishlist"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.ValueAttribute')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/ValueAttribute").then((module) => classMap["com.silkplm.model.plm.ValueAttribute"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.WCLProduct')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/WCLProduct").then((module) => classMap["com.silkplm.model.plm.WCLProduct"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.WashAndMaintenanceList')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/WashAndMaintenanceList").then((module) => classMap["com.silkplm.model.plm.WashAndMaintenanceList"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.WeeklyOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/WeeklyOffer").then((module) => classMap["com.silkplm.model.plm.WeeklyOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.Wishlist')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/Wishlist").then((module) => classMap["com.silkplm.model.plm.Wishlist"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.WorkflowCalendar')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/WorkflowCalendar").then((module) => classMap["com.silkplm.model.plm.WorkflowCalendar"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.chat.ChatMessageBase')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/chat/ChatMessageBase").then((module) => classMap["com.silkplm.model.plm.chat.ChatMessageBase"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.chat.ChatMessageInquiry')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/chat/ChatMessageInquiry").then((module) => classMap["com.silkplm.model.plm.chat.ChatMessageInquiry"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.chat.ChatPlanning')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/chat/ChatPlanning").then((module) => classMap["com.silkplm.model.plm.chat.ChatPlanning"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.AcceptanceStatusesSamplesDecisions')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/AcceptanceStatusesSamplesDecisions").then((module) => classMap["com.silkplm.model.plm.dictionaries.AcceptanceStatusesSamplesDecisions"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Accessory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Accessory").then((module) => classMap["com.silkplm.model.plm.dictionaries.Accessory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.AccessoryTechnological')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/AccessoryTechnological").then((module) => classMap["com.silkplm.model.plm.dictionaries.AccessoryTechnological"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.AdditionalCost')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/AdditionalCost").then((module) => classMap["com.silkplm.model.plm.dictionaries.AdditionalCost"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.AdditionalInformationForBranding')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/AdditionalInformationForBranding").then((module) => classMap["com.silkplm.model.plm.dictionaries.AdditionalInformationForBranding"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.AllCompaniesForSupplier')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/AllCompaniesForSupplier").then((module) => classMap["com.silkplm.model.plm.dictionaries.AllCompaniesForSupplier"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ApprovalStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ApprovalStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.ApprovalStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.AssemblySystem')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/AssemblySystem").then((module) => classMap["com.silkplm.model.plm.dictionaries.AssemblySystem"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.AssortmentGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/AssortmentGroup").then((module) => classMap["com.silkplm.model.plm.dictionaries.AssortmentGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.AuxiliaryUnit')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/AuxiliaryUnit").then((module) => classMap["com.silkplm.model.plm.dictionaries.AuxiliaryUnit"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.BasicCost')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/BasicCost").then((module) => classMap["com.silkplm.model.plm.dictionaries.BasicCost"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.BasicOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/BasicOffer").then((module) => classMap["com.silkplm.model.plm.dictionaries.BasicOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Brand')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Brand").then((module) => classMap["com.silkplm.model.plm.dictionaries.Brand"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Branding')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Branding").then((module) => classMap["com.silkplm.model.plm.dictionaries.Branding"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.BrandingDetailAttribute')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/BrandingDetailAttribute").then((module) => classMap["com.silkplm.model.plm.dictionaries.BrandingDetailAttribute"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.BrandingDetails')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/BrandingDetails").then((module) => classMap["com.silkplm.model.plm.dictionaries.BrandingDetails"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.CBMCostToSeason')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/CBMCostToSeason").then((module) => classMap["com.silkplm.model.plm.dictionaries.CBMCostToSeason"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.CNCode')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/CNCode").then((module) => classMap["com.silkplm.model.plm.dictionaries.CNCode"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Client')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Client").then((module) => classMap["com.silkplm.model.plm.dictionaries.Client"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.CodeAuxiliaryUnitNumber')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/CodeAuxiliaryUnitNumber").then((module) => classMap["com.silkplm.model.plm.dictionaries.CodeAuxiliaryUnitNumber"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Collection')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Collection").then((module) => classMap["com.silkplm.model.plm.dictionaries.Collection"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ColorVersionStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ColorVersionStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.ColorVersionStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Colors')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Colors").then((module) => classMap["com.silkplm.model.plm.dictionaries.Colors"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ColourCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ColourCategory").then((module) => classMap["com.silkplm.model.plm.dictionaries.ColourCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Commission')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Commission").then((module) => classMap["com.silkplm.model.plm.dictionaries.Commission"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.CommodityGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/CommodityGroup").then((module) => classMap["com.silkplm.model.plm.dictionaries.CommodityGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ComponentIndex')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ComponentIndex").then((module) => classMap["com.silkplm.model.plm.dictionaries.ComponentIndex"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Construction')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Construction").then((module) => classMap["com.silkplm.model.plm.dictionaries.Construction"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ConstructionPoint')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ConstructionPoint").then((module) => classMap["com.silkplm.model.plm.dictionaries.ConstructionPoint"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Constructor')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Constructor").then((module) => classMap["com.silkplm.model.plm.dictionaries.Constructor"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ContainerType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ContainerType").then((module) => classMap["com.silkplm.model.plm.dictionaries.ContainerType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ContractCondition')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ContractCondition").then((module) => classMap["com.silkplm.model.plm.dictionaries.ContractCondition"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ContractorAttribute')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ContractorAttribute").then((module) => classMap["com.silkplm.model.plm.dictionaries.ContractorAttribute"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Country')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Country").then((module) => classMap["com.silkplm.model.plm.dictionaries.Country"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Currency')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Currency").then((module) => classMap["com.silkplm.model.plm.dictionaries.Currency"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.CurrencySupplier')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/CurrencySupplier").then((module) => classMap["com.silkplm.model.plm.dictionaries.CurrencySupplier"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.CustomCounters')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/CustomCounters").then((module) => classMap["com.silkplm.model.plm.dictionaries.CustomCounters"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.DeliveryPort')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/DeliveryPort").then((module) => classMap["com.silkplm.model.plm.dictionaries.DeliveryPort"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.DeliveryType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/DeliveryType").then((module) => classMap["com.silkplm.model.plm.dictionaries.DeliveryType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.DepartmentDictionary')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/DepartmentDictionary").then((module) => classMap["com.silkplm.model.plm.dictionaries.DepartmentDictionary"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Designer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Designer").then((module) => classMap["com.silkplm.model.plm.dictionaries.Designer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.DesignerProjectStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/DesignerProjectStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.DesignerProjectStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Dimension')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Dimension").then((module) => classMap["com.silkplm.model.plm.dictionaries.Dimension"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.DutyCalculation')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/DutyCalculation").then((module) => classMap["com.silkplm.model.plm.dictionaries.DutyCalculation"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.DynamicAttribute')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/DynamicAttribute").then((module) => classMap["com.silkplm.model.plm.dictionaries.DynamicAttribute"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ERPProductWarehouse')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ERPProductWarehouse").then((module) => classMap["com.silkplm.model.plm.dictionaries.ERPProductWarehouse"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.EanView')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/EanView").then((module) => classMap["com.silkplm.model.plm.dictionaries.EanView"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.FixedCost')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/FixedCost").then((module) => classMap["com.silkplm.model.plm.dictionaries.FixedCost"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.FormNumber')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/FormNumber").then((module) => classMap["com.silkplm.model.plm.dictionaries.FormNumber"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Forwarding')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Forwarding").then((module) => classMap["com.silkplm.model.plm.dictionaries.Forwarding"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.GraphicDesignerProjectStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/GraphicDesignerProjectStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.GraphicDesignerProjectStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.HeelType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/HeelType").then((module) => classMap["com.silkplm.model.plm.dictionaries.HeelType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ImageTag')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ImageTag").then((module) => classMap["com.silkplm.model.plm.dictionaries.ImageTag"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Incoterms')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Incoterms").then((module) => classMap["com.silkplm.model.plm.dictionaries.Incoterms"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Ingredient')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Ingredient").then((module) => classMap["com.silkplm.model.plm.dictionaries.Ingredient"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Inspection')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Inspection").then((module) => classMap["com.silkplm.model.plm.dictionaries.Inspection"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.InspectionType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/InspectionType").then((module) => classMap["com.silkplm.model.plm.dictionaries.InspectionType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.IntegrationStatuses')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/IntegrationStatuses").then((module) => classMap["com.silkplm.model.plm.dictionaries.IntegrationStatuses"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.KeyVisual')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/KeyVisual").then((module) => classMap["com.silkplm.model.plm.dictionaries.KeyVisual"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.KindOfService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/KindOfService").then((module) => classMap["com.silkplm.model.plm.dictionaries.KindOfService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.KingOfPackage')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/KingOfPackage").then((module) => classMap["com.silkplm.model.plm.dictionaries.KingOfPackage"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.LabDip')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/LabDip").then((module) => classMap["com.silkplm.model.plm.dictionaries.LabDip"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Leather')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Leather").then((module) => classMap["com.silkplm.model.plm.dictionaries.Leather"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.LineDictionary')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/LineDictionary").then((module) => classMap["com.silkplm.model.plm.dictionaries.LineDictionary"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.LogisticStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/LogisticStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.LogisticStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.MainGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/MainGroup").then((module) => classMap["com.silkplm.model.plm.dictionaries.MainGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Materials')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Materials").then((module) => classMap["com.silkplm.model.plm.dictionaries.Materials"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.MethodOfExecution')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/MethodOfExecution").then((module) => classMap["com.silkplm.model.plm.dictionaries.MethodOfExecution"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.MethodOfExecutionTechnological')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/MethodOfExecutionTechnological").then((module) => classMap["com.silkplm.model.plm.dictionaries.MethodOfExecutionTechnological"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.NameTransferredToIntrastatDeclaration')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/NameTransferredToIntrastatDeclaration").then((module) => classMap["com.silkplm.model.plm.dictionaries.NameTransferredToIntrastatDeclaration"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.NextSeasonCollection')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/NextSeasonCollection").then((module) => classMap["com.silkplm.model.plm.dictionaries.NextSeasonCollection"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.NextSeasonTypeOfOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/NextSeasonTypeOfOffer").then((module) => classMap["com.silkplm.model.plm.dictionaries.NextSeasonTypeOfOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.OnlineShopType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/OnlineShopType").then((module) => classMap["com.silkplm.model.plm.dictionaries.OnlineShopType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.OrderDetailsShipmentStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/OrderDetailsShipmentStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.OrderDetailsShipmentStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.OrderQCAndCosts')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/OrderQCAndCosts").then((module) => classMap["com.silkplm.model.plm.dictionaries.OrderQCAndCosts"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.OrderQCAndCostsStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/OrderQCAndCostsStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.OrderQCAndCostsStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.OrdersStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/OrdersStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.OrdersStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.PPSampleStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/PPSampleStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.PPSampleStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.PPSamplesFinalDecision')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/PPSamplesFinalDecision").then((module) => classMap["com.silkplm.model.plm.dictionaries.PPSamplesFinalDecision"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.PPSamplesWhatsNext')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/PPSamplesWhatsNext").then((module) => classMap["com.silkplm.model.plm.dictionaries.PPSamplesWhatsNext"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.PPType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/PPType").then((module) => classMap["com.silkplm.model.plm.dictionaries.PPType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.PackagingStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/PackagingStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.PackagingStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Path')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Path").then((module) => classMap["com.silkplm.model.plm.dictionaries.Path"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Pattern')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Pattern").then((module) => classMap["com.silkplm.model.plm.dictionaries.Pattern"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.PlaceOfDelivery')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/PlaceOfDelivery").then((module) => classMap["com.silkplm.model.plm.dictionaries.PlaceOfDelivery"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Port')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Port").then((module) => classMap["com.silkplm.model.plm.dictionaries.Port"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ProductCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ProductCategory").then((module) => classMap["com.silkplm.model.plm.dictionaries.ProductCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ProductGrading')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ProductGrading").then((module) => classMap["com.silkplm.model.plm.dictionaries.ProductGrading"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ProductGradingDetail')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ProductGradingDetail").then((module) => classMap["com.silkplm.model.plm.dictionaries.ProductGradingDetail"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ProductType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ProductType").then((module) => classMap["com.silkplm.model.plm.dictionaries.ProductType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Released')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Released").then((module) => classMap["com.silkplm.model.plm.dictionaries.Released"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.RequiredTest')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/RequiredTest").then((module) => classMap["com.silkplm.model.plm.dictionaries.RequiredTest"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.RequiredTestStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/RequiredTestStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.RequiredTestStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SalesCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SalesCategory").then((module) => classMap["com.silkplm.model.plm.dictionaries.SalesCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SalesChannel')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SalesChannel").then((module) => classMap["com.silkplm.model.plm.dictionaries.SalesChannel"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SalonCategory')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SalonCategory").then((module) => classMap["com.silkplm.model.plm.dictionaries.SalonCategory"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SamplePoland')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SamplePoland").then((module) => classMap["com.silkplm.model.plm.dictionaries.SamplePoland"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SampleStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SampleStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.SampleStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SampleStatusFashion')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SampleStatusFashion").then((module) => classMap["com.silkplm.model.plm.dictionaries.SampleStatusFashion"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Seasonality')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Seasonality").then((module) => classMap["com.silkplm.model.plm.dictionaries.Seasonality"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Session')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Session").then((module) => classMap["com.silkplm.model.plm.dictionaries.Session"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ShipmentSampleStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ShipmentSampleStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.ShipmentSampleStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Shipowner')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Shipowner").then((module) => classMap["com.silkplm.model.plm.dictionaries.Shipowner"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.ShoeStiffness')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/ShoeStiffness").then((module) => classMap["com.silkplm.model.plm.dictionaries.ShoeStiffness"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Size')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Size").then((module) => classMap["com.silkplm.model.plm.dictionaries.Size"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SizeCoding')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SizeCoding").then((module) => classMap["com.silkplm.model.plm.dictionaries.SizeCoding"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SizeGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SizeGroup").then((module) => classMap["com.silkplm.model.plm.dictionaries.SizeGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SizeMapping')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SizeMapping").then((module) => classMap["com.silkplm.model.plm.dictionaries.SizeMapping"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SizeRanges')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SizeRanges").then((module) => classMap["com.silkplm.model.plm.dictionaries.SizeRanges"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SizesPercentageBreakdown')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SizesPercentageBreakdown").then((module) => classMap["com.silkplm.model.plm.dictionaries.SizesPercentageBreakdown"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SmallAndLargeSize')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SmallAndLargeSize").then((module) => classMap["com.silkplm.model.plm.dictionaries.SmallAndLargeSize"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.StatusIntegrationLogger')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/StatusIntegrationLogger").then((module) => classMap["com.silkplm.model.plm.dictionaries.StatusIntegrationLogger"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.StatusShopify')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/StatusShopify").then((module) => classMap["com.silkplm.model.plm.dictionaries.StatusShopify"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.StyleCut')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/StyleCut").then((module) => classMap["com.silkplm.model.plm.dictionaries.StyleCut"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.SupplierType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/SupplierType").then((module) => classMap["com.silkplm.model.plm.dictionaries.SupplierType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TechDetailsComponentIndexDto')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TechDetailsComponentIndexDto").then((module) => classMap["com.silkplm.model.plm.dictionaries.TechDetailsComponentIndexDto"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TechnicalDictionaryForCalculation')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TechnicalDictionaryForCalculation").then((module) => classMap["com.silkplm.model.plm.dictionaries.TechnicalDictionaryForCalculation"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TechnologicalDetails')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TechnologicalDetails").then((module) => classMap["com.silkplm.model.plm.dictionaries.TechnologicalDetails"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TechnologicalProductComponent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TechnologicalProductComponent").then((module) => classMap["com.silkplm.model.plm.dictionaries.TechnologicalProductComponent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TechnologicalProductType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TechnologicalProductType").then((module) => classMap["com.silkplm.model.plm.dictionaries.TechnologicalProductType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TechnologicalRealizationStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TechnologicalRealizationStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.TechnologicalRealizationStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TechnologicalStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TechnologicalStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.TechnologicalStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TechnologistProjectStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TechnologistProjectStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.TechnologistProjectStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TermsOfPayment')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TermsOfPayment").then((module) => classMap["com.silkplm.model.plm.dictionaries.TermsOfPayment"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Tiering')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Tiering").then((module) => classMap["com.silkplm.model.plm.dictionaries.Tiering"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TransitTime')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TransitTime").then((module) => classMap["com.silkplm.model.plm.dictionaries.TransitTime"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TransportCost')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TransportCost").then((module) => classMap["com.silkplm.model.plm.dictionaries.TransportCost"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TransportType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TransportType").then((module) => classMap["com.silkplm.model.plm.dictionaries.TransportType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TypeOfAssessment')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TypeOfAssessment").then((module) => classMap["com.silkplm.model.plm.dictionaries.TypeOfAssessment"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TypeOfBox')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TypeOfBox").then((module) => classMap["com.silkplm.model.plm.dictionaries.TypeOfBox"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TypeOfDocument')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TypeOfDocument").then((module) => classMap["com.silkplm.model.plm.dictionaries.TypeOfDocument"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TypeOfFootwear')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TypeOfFootwear").then((module) => classMap["com.silkplm.model.plm.dictionaries.TypeOfFootwear"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TypeOfNumbering')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TypeOfNumbering").then((module) => classMap["com.silkplm.model.plm.dictionaries.TypeOfNumbering"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TypeOfOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TypeOfOffer").then((module) => classMap["com.silkplm.model.plm.dictionaries.TypeOfOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TypeOfSole')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TypeOfSole").then((module) => classMap["com.silkplm.model.plm.dictionaries.TypeOfSole"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.TypeUpperWidth')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/TypeUpperWidth").then((module) => classMap["com.silkplm.model.plm.dictionaries.TypeUpperWidth"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Unit')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Unit").then((module) => classMap["com.silkplm.model.plm.dictionaries.Unit"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.UsageDefine')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/UsageDefine").then((module) => classMap["com.silkplm.model.plm.dictionaries.UsageDefine"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.UsedPatternNumbersRange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/UsedPatternNumbersRange").then((module) => classMap["com.silkplm.model.plm.dictionaries.UsedPatternNumbersRange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.VatLevel')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/VatLevel").then((module) => classMap["com.silkplm.model.plm.dictionaries.VatLevel"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.WCLStatus')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/WCLStatus").then((module) => classMap["com.silkplm.model.plm.dictionaries.WCLStatus"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Warehouse')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Warehouse").then((module) => classMap["com.silkplm.model.plm.dictionaries.Warehouse"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.Warming')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/Warming").then((module) => classMap["com.silkplm.model.plm.dictionaries.Warming"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.WashAndMaintenance')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/WashAndMaintenance").then((module) => classMap["com.silkplm.model.plm.dictionaries.WashAndMaintenance"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.dictionaries.YesNo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/dictionaries/YesNo").then((module) => classMap["com.silkplm.model.plm.dictionaries.YesNo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.marketPlace.SuppliersCompanies')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/marketPlace/SuppliersCompanies").then((module) => classMap["com.silkplm.model.plm.marketPlace.SuppliersCompanies"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.tabInquiry.InquiryTabCore')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/tabInquiry/InquiryTabCore").then((module) => classMap["com.silkplm.model.plm.tabInquiry.InquiryTabCore"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.tabInquiry.InquiryTabSuppliersCore')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/tabInquiry/InquiryTabSuppliersCore").then((module) => classMap["com.silkplm.model.plm.tabInquiry.InquiryTabSuppliersCore"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.plm.tabInquiry.ProposedSupplierDetails')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/plm/tabInquiry/ProposedSupplierDetails").then((module) => classMap["com.silkplm.model.plm.tabInquiry.ProposedSupplierDetails"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.shipment.ShipmentContract')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/shipment/ShipmentContract").then((module) => classMap["com.silkplm.model.shipment.ShipmentContract"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.shipment.ShipmentInquiry')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/shipment/ShipmentInquiry").then((module) => classMap["com.silkplm.model.shipment.ShipmentInquiry"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.shipment.ShipmentInquiryExchangeRate')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/shipment/ShipmentInquiryExchangeRate").then((module) => classMap["com.silkplm.model.shipment.ShipmentInquiryExchangeRate"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.shipment.ShipmentInquiryOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/shipment/ShipmentInquiryOffer").then((module) => classMap["com.silkplm.model.shipment.ShipmentInquiryOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.shipment.ShipmentWeeklyContractor')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/shipment/ShipmentWeeklyContractor").then((module) => classMap["com.silkplm.model.shipment.ShipmentWeeklyContractor"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.shipment.ShipmentWeeklyOffer')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/shipment/ShipmentWeeklyOffer").then((module) => classMap["com.silkplm.model.shipment.ShipmentWeeklyOffer"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.sticky.StickyNote')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/sticky/StickyNote").then((module) => classMap["com.silkplm.model.sticky.StickyNote"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.ApplicationUser')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/ApplicationUser").then((module) => classMap["com.silkplm.model.users.ApplicationUser"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.CompanyConfigurationFunctionalFlag')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/CompanyConfigurationFunctionalFlag").then((module) => classMap["com.silkplm.model.users.CompanyConfigurationFunctionalFlag"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.CompanyCustomAlgorithmsConfiguration')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/CompanyCustomAlgorithmsConfiguration").then((module) => classMap["com.silkplm.model.users.CompanyCustomAlgorithmsConfiguration"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.CompanyDatesConfiguration')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/CompanyDatesConfiguration").then((module) => classMap["com.silkplm.model.users.CompanyDatesConfiguration"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.Department')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/Department").then((module) => classMap["com.silkplm.model.users.Department"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.Domain')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/Domain").then((module) => classMap["com.silkplm.model.users.Domain"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.Group')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/Group").then((module) => classMap["com.silkplm.model.users.Group"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.ModulesConfiguration')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/ModulesConfiguration").then((module) => classMap["com.silkplm.model.users.ModulesConfiguration"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.Organization')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/Organization").then((module) => classMap["com.silkplm.model.users.Organization"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.OrganizationStructure')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/OrganizationStructure").then((module) => classMap["com.silkplm.model.users.OrganizationStructure"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.Role')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/Role").then((module) => classMap["com.silkplm.model.users.Role"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.UserConfigEntry')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/UserConfigEntry").then((module) => classMap["com.silkplm.model.users.UserConfigEntry"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.UserNotification')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/UserNotification").then((module) => classMap["com.silkplm.model.users.UserNotification"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.model.users.UserSettings')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/model/users/UserSettings").then((module) => classMap["com.silkplm.model.users.UserSettings"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.organization.StickyNoteType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/organization/StickyNoteType").then((module) => classMap["com.silkplm.organization.StickyNoteType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.CategoryAttributeEventChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/CategoryAttributeEventChange").then((module) => classMap["com.silkplm.push.CategoryAttributeEventChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.DelayedTaskComplete')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/DelayedTaskComplete").then((module) => classMap["com.silkplm.push.DelayedTaskComplete"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.DictionaryChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/DictionaryChange").then((module) => classMap["com.silkplm.push.DictionaryChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.DomainVerificationChanged')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/DomainVerificationChanged").then((module) => classMap["com.silkplm.push.DomainVerificationChanged"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.DynamicAttributeEventChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/DynamicAttributeEventChange").then((module) => classMap["com.silkplm.push.DynamicAttributeEventChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.DynamicColumnEventChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/DynamicColumnEventChange").then((module) => classMap["com.silkplm.push.DynamicColumnEventChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.DynamicDictionaryEventChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/DynamicDictionaryEventChange").then((module) => classMap["com.silkplm.push.DynamicDictionaryEventChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.DynamicEntityChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/DynamicEntityChange").then((module) => classMap["com.silkplm.push.DynamicEntityChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.DynamicEntityEventChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/DynamicEntityEventChange").then((module) => classMap["com.silkplm.push.DynamicEntityEventChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.FormsChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/FormsChange").then((module) => classMap["com.silkplm.push.FormsChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.NewBackgroundTaskEvent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/NewBackgroundTaskEvent").then((module) => classMap["com.silkplm.push.NewBackgroundTaskEvent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.NewDocumentEvent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/NewDocumentEvent").then((module) => classMap["com.silkplm.push.NewDocumentEvent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.NewInquiryMessageEvent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/NewInquiryMessageEvent").then((module) => classMap["com.silkplm.push.NewInquiryMessageEvent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.NewInspirationMessageEvent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/NewInspirationMessageEvent").then((module) => classMap["com.silkplm.push.NewInspirationMessageEvent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.NewNotification')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/NewNotification").then((module) => classMap["com.silkplm.push.NewNotification"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.NewSupplierMessageEvent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/NewSupplierMessageEvent").then((module) => classMap["com.silkplm.push.NewSupplierMessageEvent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.ObservableEntityChange')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/ObservableEntityChange").then((module) => classMap["com.silkplm.push.ObservableEntityChange"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.PermissionsChanged')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/PermissionsChanged").then((module) => classMap["com.silkplm.push.PermissionsChanged"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.PrestaShopIntegrationSentEvent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/PrestaShopIntegrationSentEvent").then((module) => classMap["com.silkplm.push.PrestaShopIntegrationSentEvent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.ProgressInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/ProgressInfo").then((module) => classMap["com.silkplm.push.ProgressInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.PushHealthcheckEvent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/PushHealthcheckEvent").then((module) => classMap["com.silkplm.push.PushHealthcheckEvent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.RefreshList')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/RefreshList").then((module) => classMap["com.silkplm.push.RefreshList"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.SessionChanged')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/SessionChanged").then((module) => classMap["com.silkplm.push.SessionChanged"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.SessionTerminated')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/SessionTerminated").then((module) => classMap["com.silkplm.push.SessionTerminated"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.SessionTimeout')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/SessionTimeout").then((module) => classMap["com.silkplm.push.SessionTimeout"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.ShutdownMessage')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/ShutdownMessage").then((module) => classMap["com.silkplm.push.ShutdownMessage"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.SubiektIntegrationSentEvent')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/SubiektIntegrationSentEvent").then((module) => classMap["com.silkplm.push.SubiektIntegrationSentEvent"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.SubscribedMessage')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/SubscribedMessage").then((module) => classMap["com.silkplm.push.SubscribedMessage"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.push.SubscriptionStatusChanged')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/push/SubscriptionStatusChanged").then((module) => classMap["com.silkplm.push.SubscriptionStatusChanged"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.reports.ReportGroup')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/reports/ReportGroup").then((module) => classMap["com.silkplm.reports.ReportGroup"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.CloneOptions')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/CloneOptions").then((module) => classMap["com.silkplm.rpc.CloneOptions"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.FeatureFlag')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/FeatureFlag").then((module) => classMap["com.silkplm.rpc.FeatureFlag"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.RpcMustWaitException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/RpcMustWaitException").then((module) => classMap["com.silkplm.rpc.RpcMustWaitException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.ApplicationVersion')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/ApplicationVersion").then((module) => classMap["com.silkplm.rpc.dto.ApplicationVersion"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.CanDeleteEntityWithInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/CanDeleteEntityWithInfo").then((module) => classMap["com.silkplm.rpc.dto.CanDeleteEntityWithInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.ColorVersionWithColorDto')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/ColorVersionWithColorDto").then((module) => classMap["com.silkplm.rpc.dto.ColorVersionWithColorDto"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.ComplexNewRecord')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/ComplexNewRecord").then((module) => classMap["com.silkplm.rpc.dto.ComplexNewRecord"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.ComplexNewRecordDetail')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/ComplexNewRecordDetail").then((module) => classMap["com.silkplm.rpc.dto.ComplexNewRecordDetail"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.ComplexNewRecordError')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/ComplexNewRecordError").then((module) => classMap["com.silkplm.rpc.dto.ComplexNewRecordError"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.ComplexNewRecordExtension')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/ComplexNewRecordExtension").then((module) => classMap["com.silkplm.rpc.dto.ComplexNewRecordExtension"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.DecimalWithCurrency')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/DecimalWithCurrency").then((module) => classMap["com.silkplm.rpc.dto.DecimalWithCurrency"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.DelayedTask')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/DelayedTask").then((module) => classMap["com.silkplm.rpc.dto.DelayedTask"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.DepartmentInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/DepartmentInfo").then((module) => classMap["com.silkplm.rpc.dto.DepartmentInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.IdWithPerms')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/IdWithPerms").then((module) => classMap["com.silkplm.rpc.dto.IdWithPerms"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.IntegrationBusParameters')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/IntegrationBusParameters").then((module) => classMap["com.silkplm.rpc.dto.IntegrationBusParameters"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.InvitationInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/InvitationInfo").then((module) => classMap["com.silkplm.rpc.dto.InvitationInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.Language')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/Language").then((module) => classMap["com.silkplm.rpc.dto.Language"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.OrganizationDataInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/OrganizationDataInfo").then((module) => classMap["com.silkplm.rpc.dto.OrganizationDataInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.OrganizationPublicInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/OrganizationPublicInfo").then((module) => classMap["com.silkplm.rpc.dto.OrganizationPublicInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.PantoneColor')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/PantoneColor").then((module) => classMap["com.silkplm.rpc.dto.PantoneColor"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.PaymentPortalLink')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/PaymentPortalLink").then((module) => classMap["com.silkplm.rpc.dto.PaymentPortalLink"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.PaymentSlotsInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/PaymentSlotsInfo").then((module) => classMap["com.silkplm.rpc.dto.PaymentSlotsInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.PermissionInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/PermissionInfo").then((module) => classMap["com.silkplm.rpc.dto.PermissionInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.PlannerPMWithProductInSeasonInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/PlannerPMWithProductInSeasonInfo").then((module) => classMap["com.silkplm.rpc.dto.PlannerPMWithProductInSeasonInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.ProductGradingDataInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/ProductGradingDataInfo").then((module) => classMap["com.silkplm.rpc.dto.ProductGradingDataInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.ProductGradingDetailResultInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/ProductGradingDetailResultInfo").then((module) => classMap["com.silkplm.rpc.dto.ProductGradingDetailResultInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.RegionsConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/RegionsConfig").then((module) => classMap["com.silkplm.rpc.dto.RegionsConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.RoleAndUserWhoDelegatedInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/RoleAndUserWhoDelegatedInfo").then((module) => classMap["com.silkplm.rpc.dto.RoleAndUserWhoDelegatedInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.SelectionMaterializeResponse')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/SelectionMaterializeResponse").then((module) => classMap["com.silkplm.rpc.dto.SelectionMaterializeResponse"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.SeleniumConfig')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/SeleniumConfig").then((module) => classMap["com.silkplm.rpc.dto.SeleniumConfig"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.SignUpAutoconf')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/SignUpAutoconf").then((module) => classMap["com.silkplm.rpc.dto.SignUpAutoconf"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.SplendiProduct')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/SplendiProduct").then((module) => classMap["com.silkplm.rpc.dto.SplendiProduct"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.StreamEditResult')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/StreamEditResult").then((module) => classMap["com.silkplm.rpc.dto.StreamEditResult"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.StreamSelection')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/StreamSelection").then((module) => classMap["com.silkplm.rpc.dto.StreamSelection"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.SummaryRow')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/SummaryRow").then((module) => classMap["com.silkplm.rpc.dto.SummaryRow"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.UserInfo')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/UserInfo").then((module) => classMap["com.silkplm.rpc.dto.UserInfo"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.VersionNode')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/VersionNode").then((module) => classMap["com.silkplm.rpc.dto.VersionNode"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.integrations.IdMapping')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/integrations/IdMapping").then((module) => classMap["com.silkplm.rpc.dto.integrations.IdMapping"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.plm.WarningAndBugs')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/plm/WarningAndBugs").then((module) => classMap["com.silkplm.rpc.dto.plm.WarningAndBugs"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.streaming.FormStreamingQuery')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/streaming/FormStreamingQuery").then((module) => classMap["com.silkplm.rpc.dto.streaming.FormStreamingQuery"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.dto.streaming.StreamingQueryColOrder')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/dto/streaming/StreamingQueryColOrder").then((module) => classMap["com.silkplm.rpc.dto.streaming.StreamingQueryColOrder"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.FileImportException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/FileImportException").then((module) => classMap["com.silkplm.rpc.exceptions.FileImportException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.InvalidTaxIDException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/InvalidTaxIDException").then((module) => classMap["com.silkplm.rpc.exceptions.InvalidTaxIDException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.LastOwnerCannotBeDeletedException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/LastOwnerCannotBeDeletedException").then((module) => classMap["com.silkplm.rpc.exceptions.LastOwnerCannotBeDeletedException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.NoOwnerException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/NoOwnerException").then((module) => classMap["com.silkplm.rpc.exceptions.NoOwnerException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.OrganizationDeletedException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/OrganizationDeletedException").then((module) => classMap["com.silkplm.rpc.exceptions.OrganizationDeletedException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.RelatedRecordsException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/RelatedRecordsException").then((module) => classMap["com.silkplm.rpc.exceptions.RelatedRecordsException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.RoleIsAssignedException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/RoleIsAssignedException").then((module) => classMap["com.silkplm.rpc.exceptions.RoleIsAssignedException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.RoleIsNotAvailableException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/RoleIsNotAvailableException").then((module) => classMap["com.silkplm.rpc.exceptions.RoleIsNotAvailableException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.TaskBrakeException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/TaskBrakeException").then((module) => classMap["com.silkplm.rpc.exceptions.TaskBrakeException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.TooManyUsersException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/TooManyUsersException").then((module) => classMap["com.silkplm.rpc.exceptions.TooManyUsersException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.exceptions.UserCannotBeDeletedException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/exceptions/UserCannotBeDeletedException").then((module) => classMap["com.silkplm.rpc.exceptions.UserCannotBeDeletedException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.healthcheck.RpcFruitsException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/healthcheck/RpcFruitsException").then((module) => classMap["com.silkplm.rpc.healthcheck.RpcFruitsException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.healthcheck.methods.ArgumentObject')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/healthcheck/methods/ArgumentObject").then((module) => classMap["com.silkplm.rpc.healthcheck.methods.ArgumentObject"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.healthcheck.methods.BusinessException')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/healthcheck/methods/BusinessException").then((module) => classMap["com.silkplm.rpc.healthcheck.methods.BusinessException"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.healthcheck.methods.ComplexType')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/healthcheck/methods/ComplexType").then((module) => classMap["com.silkplm.rpc.healthcheck.methods.ComplexType"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.healthcheck.methods.KotlinData')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/healthcheck/methods/KotlinData").then((module) => classMap["com.silkplm.rpc.healthcheck.methods.KotlinData"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.healthcheck.model.Apple')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/healthcheck/model/Apple").then((module) => classMap["com.silkplm.rpc.healthcheck.model.Apple"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.healthcheck.model.Basket')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/healthcheck/model/Basket").then((module) => classMap["com.silkplm.rpc.healthcheck.model.Basket"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.healthcheck.model.Worm')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/healthcheck/model/Worm").then((module) => classMap["com.silkplm.rpc.healthcheck.model.Worm"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.ImageMetadata')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/ImageMetadata").then((module) => classMap["com.silkplm.rpc.plm.ImageMetadata"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.ListOfImageTag')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/ListOfImageTag").then((module) => classMap["com.silkplm.rpc.plm.ListOfImageTag"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.StreamResult')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/StreamResult").then((module) => classMap["com.silkplm.rpc.plm.StreamResult"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.BillOfMaterialsService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/BillOfMaterialsService").then((module) => classMap["com.silkplm.rpc.plm.services.BillOfMaterialsService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.DelegationService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/DelegationService").then((module) => classMap["com.silkplm.rpc.plm.services.DelegationService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.DimensionalService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/DimensionalService").then((module) => classMap["com.silkplm.rpc.plm.services.DimensionalService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.EansService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/EansService").then((module) => classMap["com.silkplm.rpc.plm.services.EansService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.IntegrationViewService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/IntegrationViewService").then((module) => classMap["com.silkplm.rpc.plm.services.IntegrationViewService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.OrderDetailsService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/OrderDetailsService").then((module) => classMap["com.silkplm.rpc.plm.services.OrderDetailsService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.ProductService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/ProductService").then((module) => classMap["com.silkplm.rpc.plm.services.ProductService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.RoleService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/RoleService").then((module) => classMap["com.silkplm.rpc.plm.services.RoleService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.SeasonService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/SeasonService").then((module) => classMap["com.silkplm.rpc.plm.services.SeasonService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.SupplierService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/SupplierService").then((module) => classMap["com.silkplm.rpc.plm.services.SupplierService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.TechnicalDictionaryForCalculationService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/TechnicalDictionaryForCalculationService").then((module) => classMap["com.silkplm.rpc.plm.services.TechnicalDictionaryForCalculationService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.TermsOfPaymentService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/TermsOfPaymentService").then((module) => classMap["com.silkplm.rpc.plm.services.TermsOfPaymentService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.rpc.plm.services.TrancheService')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/rpc/plm/services/TrancheService").then((module) => classMap["com.silkplm.rpc.plm.services.TrancheService"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.users.DynamicPermission')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/users/DynamicPermission").then((module) => classMap["com.silkplm.users.DynamicPermission"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.users.Permission')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/users/Permission").then((module) => classMap["com.silkplm.users.Permission"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.xorg.Attachment')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/xorg/Attachment").then((module) => classMap["com.silkplm.xorg.Attachment"] = module.default));
    }
    if(!classMap.hasOwnProperty('com.silkplm.xorg.AttachmentsData')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/com/silkplm/xorg/AttachmentsData").then((module) => classMap["com.silkplm.xorg.AttachmentsData"] = module.default));
    }
    if(!classMap.hasOwnProperty('org.apache.poi.ss.usermodel.Row')) {
        allImports.push(import(/* webpackMode: "eager" */ "../server/org/apache/poi/ss/usermodel/Row").then((module) => classMap["org.apache.poi.ss.usermodel.Row"] = module.default));
    }
    await Promise.all(allImports);

    return classMap;
}

class RpcClass extends RpcBase {
    constructor(props) {
        super(props);
    }
    lockDuringNextRequest() {
        return RpcClass.lockDuringNextRequest();
    }

    async doPost(relativeUri, dataJson) {
        return RpcClass.doPost(relativeUri, dataJson);
    }

    /**
     * @param methodPath {string}
     * @param parameters {[Object]}
     * @returns {ExtendedPromise}
     */
    rpcCall(methodPath, parameters){
        return RpcClass.rpcCall(methodPath, parameters);
    }

    /**
     * @param exception
     * @returns *
     */
    decodeException(exception) {
        RpcClass.decodeException(exception);
    }

}


RpcClass.previousStatus = true;
RpcClass.userListensForEvents = false;
RpcClass.wsPipe = null;
RpcClass.brokenPipeTimer = null;
RpcClass.lastPushTimestamp = 0;
RpcClass.sessionCookie = "";

RpcClass.baseAddress = null;
RpcClass.agentInstance = superagent;
RpcClass.csrfToken = localStorage.getItem('RpcClass.csrf');
RpcClass.locale = window.navigator.userLanguage || window.navigator.language;
RpcClass.deduplicationSet = new Set();
RpcClass.requestsStatus = { counter: 0 };

RpcClass.savedContext = null;
RpcClass.EventBus = EventBus;

RpcClass.logSuccessful = localStorage.getItem("log.logSuccessfulRpc") && localStorage.getItem("log.logSuccessfulRpc") === "true";

RpcClass.rebootCaptured = false

RpcClass.saveRpcContext = function(){
    return {
        previousStatus:  RpcClass.previousStatus,
        userListensForEvents: RpcClass.userListensForEvents,
        wsPipe: RpcClass.wsPipe,
        brokenPipeTimer: RpcClass.brokenPipeTimer,
        lastPushTimestamp: RpcClass.lastPushTimestamp,

        baseAddress: RpcClass.baseAddress,
        agentInstance: RpcClass.agentInstance,
        csrfToken: RpcClass.csrfToken,
        locale: RpcClass.locale,
        deduplicationSet: RpcClass.deduplicationSet,
        EventBus: RpcClass.EventBus,
        requestsStatus: RpcClass.requestsStatus
    }
}


RpcClass.rHOMLA_DEMO_1 = function(context){
    RpcClass.previousStatus= context.previousStatus;
    RpcClass.userListensForEvents= context.userListensForEvents;
    RpcClass.wsPipe= context.wsPipe;
    RpcClass.brokenPipeTimer= context.brokenPipeTimer;
    RpcClass.lastPushTimestamp= context.lastPushTimestamp;

    RpcClass.baseAddress= context.baseAddress;
    RpcClass.agentInstance= context.agentInstance;
    RpcClass.csrfToken= context.csrfToken;
    RpcClass.locale= context.locale;
    RpcClass.deduplicationSet= context.deduplicationSet;
    RpcClass.EventBus = context.EventBus;
    RpcClass.requestsStatus = context.requestsStatus;
}

RpcClass.changeContextOnce = function(ctx){
    RpcClass.savedContext = RpcClass.saveRpcContext();
    RpcClass.restoreRpcContext(ctx);
}

RpcClass.stopWsPipeFallback = function(){
    if(RpcClass.brokenPipeTimer && RpcClass.brokenPipeTimer !== true){
        clearTimeout(RpcClass.brokenPipeTimer);
    }

    RpcClass.lastPushTimestamp = 0;
    RpcClass.previousStatus = true;
    RpcClass.userListensForEvents = false;
    RpcClass.wsPipe = null
    RpcClass.brokenPipeTimer = null;
}


RpcClass.wsPipeBroken = function(){
    if(RpcClass.brokenPipeTimer){
        return;
    }

    RpcClass.notifyServer();
}

RpcClass.notifyServer = function(){
    if(!RpcClass.userListensForEvents || !RpcClass.wsPipe) {
        return false;
    }
    if(RpcClass.wsPipe.websocket.readyState === WebSocket.OPEN){
        return false;
    }
    RpcClass.brokenPipeTimer = true;
    let prom = RpcClass.rpcCall('/rpc/session/report-broken-web-socket', []);

    prom.then(function(){
        RpcClass.nextWsPipeBroken();
        RpcClass.EventBus.$emit(Events.pushChannelFallbackRequested);
    }).catch(function(){
        RpcClass.nextWsPipeBroken();
    })
    return true;
}

RpcClass.fallbackKeepAlive = function (callback){
    let prom = RpcClass.rpcCall('/rpc/session/keep-alive', []);
    prom.then(() => callback(true)).catch(() => callback(false));
}

RpcClass.nextWsPipeBroken = function(){
    RpcClass.brokenPipeTimer = null;
    if(!RpcClass.userListensForEvents || !RpcClass.wsPipe) {
        return;
    }
    if(RpcClass.wsPipe.websocket.readyState === WebSocket.OPEN){
        return;
    }
    RpcClass.brokenPipeTimer = setTimeout(function(){
        RpcClass.notifyServer();
    }, 120 * 1000);
}

RpcClass.lockDuringNextRequest = function() {
        Client.lockDuringNextRequest();
};


/**
 @return {module:superagent.Request}
 */
RpcClass.doPostMultipart = async function(relativeUri, dataArray, ctx, target, p){
    let req = ctx.agentInstance.post(target);
    let start = performance.now();
    if(window.hasOwnProperty('_frontendBuildTag')){
        req.set("x-build-tag", window['_frontendBuildTag']);
        req.set("x-version", window['_frontendVersion']);
    }
    if(p['tag']){
        req.set("x-tag", p['tag']);
    }
    if(window["_windowUUID"]){
        req.set("x-wuuid", window["_windowUUID"]);
    }

    if(ctx.csrfToken){
        req.set("x-token", ctx.csrfToken);
    }
    req.on("end", () =>{
        Log.info("File uploaded to server in: %c " +  Math.round(performance.now() - start) + "ms", {css: ["color: #208020"]});
    });

    p["req"] = req;
    req.withCredentials();

    req.set("Accept", "application/json");
    if(ctx.csrfToken){
        req.set("x-token", ctx.csrfToken);
    }
    if(ctx.userListensForEvents && ctx.wsPipe){
        let status = (ctx.wsPipe.websocket.readyState === WebSocket.OPEN ||
            ctx.wsPipe.websocket.readyState === WebSocket.CONNECTING);
        if(!status || !ctx.previousStatus){
            ctx.previousBroken = true;
            req.set("x-collect-push", ctx.lastPushTimestamp);
        }
        ctx.previousStatus = status;
    }


    for(let i=0; i< dataArray.length; i++){
        let param = dataArray[i];
        if(param instanceof File) {
            let fName = he.encode(param.name);
            req.attach("arg" + i, param, fName);
        }
        else if(param instanceof Buffer){
            let fName = he.encode(param['fileName']);
            req.attach("arg" + i, param, fName);
        } else if(param instanceof FileList){
            if(param.length == 0){
                req.field("arg" + i, "empty-file-list");
            }
            for(let j = 0; j < param.length; j++) {
                let file = param.item(j);
                let fName = he.encode(file.name);
                req.attach("arg" + i, file, fName);
            }
        } else {
            req.field("arg" + i, JSON.stringify(param));
        }
    }

    Client.interceptReq(req);
    let response = await req;

    if (response.header["x-token"]) {
        if (response.header["x-token"] !== ctx.csrfToken) {
            ctx.csrfToken = response.header["x-token"];
            localStorage.setItem('RpcClass.csrf', ctx.csrfToken);
        }
    }
    return response;
}

RpcClass.cordovaDoPostMultipart = async function(relativeUri, dataArray, ctx, target, p){
    let headers = {}
        try{
        let start = performance.now();
        if(window.hasOwnProperty('_frontendBuildTag')){
            headers["x-build-tag"] = window['_frontendBuildTag'];
            headers["x-version"] = window['_frontendVersion'];
        }
        if(p['tag']){
            headers["x-tag"] = p['tag'];
        }
        if(window["_windowUUID"]){
            headers["x-wuuid"] = window["_windowUUID"];
        }

        if(ctx.csrfToken){
            headers["x-token"] = ctx.csrfToken;
        }

        headers["Accept"] = "application/json";
        if(ctx.csrfToken){
            headers["x-token"] = ctx.csrfToken;
        }
        if(ctx.userListensForEvents && ctx.wsPipe){
            let status = (ctx.wsPipe.websocket.readyState === WebSocket.OPEN ||
                ctx.wsPipe.websocket.readyState === WebSocket.CONNECTING);
            if(!status || !ctx.previousStatus){
                ctx.previousBroken = true;
                headers["x-collect-push"] = ctx.lastPushTimestamp.toString();
            }
            ctx.previousStatus = status;
        }

        var formData = new FormData();

        for(let i=0; i< dataArray.length; i++){
            let param = dataArray[i];
            if(param instanceof File || param instanceof Blob) {
                let fName = he.encode(param.name);
                formData.append("arg" + i, param, fName);
                            }
            else if(param instanceof Buffer){
                let fName = he.encode(param['fileName']);
                formData.append("arg" + i, param, fName);
                            } else if(param instanceof FileList){
                if(param.length == 0){
                                        formData.append("arg" + i, "empty-file-list");
                }
                for(let j = 0; j < param.length; j++) {
                    let file = param.item(j);
                    let fName = he.encode(file.name);
                    formData.append("arg" + i, param, fName);
                                    }
            } else {
                                formData.append("arg" + i, JSON.stringify(param));
            }
        }
    }catch (e) {
        console.error(e);
        throw e;
    }
    let resPromise = new Promise((resolve, reject) => {
                cordova.plugin.http.setDataSerializer('multipart');
        cordova.plugin.http.post(
            target,
            formData,
            headers,
            function(response) {
                                resolve(response);
            }, function(response) {
                                resolve(response);
            });
    });
    resPromise.on = function( ev, callback ){
        console.log("resPromise on, " + ev + " -> section multipart")
    }
    p["req"] = resPromise;
    let pushCollector = false;

    
    try {
        
        let response = await resPromise;
        
        response.body = JSON.parse(response.data);

        
        if (response.headers["x-token"]) {
            if (response.headers["x-token"] !== ctx.csrfToken) {
                ctx.csrfToken = response.headers["x-token"];
                localStorage.setItem('RpcClass.csrf', ctx.csrfToken);
            }
        }
        let cookie = response.headers["set-cookie"];
        if(cookie){
            let parsed = parseCookie(cookie);
            if(parsed['sess']) {
                RpcClass.sessionCookie = parsed['sess'];
            }
        }

        if (pushCollector) {
            if(!response.body || response.body['hasExceptions']) {
                if(ctx.wsPipe){
                    ctx.wsPipe.fallbackPushReceived(false);
                }
            }else{
                if(ctx.wsPipe){
                    ctx.wsPipe.fallbackPushReceived(true);
                }
            }
        }

        return response;
    } catch (e){
        console.error(e);
        if (pushCollector) {
            if(ctx.wsPipe){
                ctx.wsPipe.fallbackPushReceived(false);
            }
        }
        throw e;
    }
}

RpcClass.doPost = async function(callType, relativeUri, dataJson, ctx, p){
    if(window['isCordova']){
        return await cordovaDoPost(callType, relativeUri, dataJson, ctx, p);
    }
    if(!ctx){
        ctx = RpcClass;
    }
    let target = relativeUri;

    if(ctx.baseAddress){
        target = ctx.baseAddress + target;
    } else if(window && window["_apiEndpoint"]){
        target =  window["_apiEndpoint"] + target;
    }

    if(callType === "post-multipart"){
        return RpcClass.doPostMultipart(relativeUri, dataJson, ctx, target, p);
    }

    if(callType === 'post-json' && ctx.wsPipe && ctx.wsPipe && ctx.wsPipe.websocket.readyState === WebSocket.OPEN){
        return ctx.wsPipe.doPost(relativeUri, dataJson, ctx.csrfToken, target, p);
    }

    let dataJsonString = JSON.stringify(dataJson);
    let req = ctx.agentInstance.post(target).
    set("Content-Type", "application/json").
    set("Accept", "application/json");
    req.withCredentials();

    if(window.hasOwnProperty('_frontendBuildTag')){
        req.set("x-build-tag", window['_frontendBuildTag']);
        req.set("x-version", window['_frontendVersion']);
    }

    if(window["_windowUUID"]){
        req.set("x-wuuid", window["_windowUUID"]);
    }

    if(p['tag']){
        req.set("x-tag", p['tag']);
    }
    if(ctx.csrfToken){
        req.set("x-token", ctx.csrfToken);
    }
    p["req"] = req;

    let pushCollector = false;
    if(ctx.userListensForEvents && ctx.wsPipe){
        let status = (ctx.wsPipe.websocket.readyState === WebSocket.OPEN ||
            ctx.wsPipe.websocket.readyState === WebSocket.CONNECTING);
        if(!status || !ctx.previousStatus){
            ctx.previousBroken = true;
            pushCollector = true;
            req.set("x-collect-push", ctx.lastPushTimestamp);
        }
        ctx.previousStatus = status;
    }
    Client.interceptReq(req);
    try {
        let response;
        if (dataJsonString !== null && dataJsonString !== undefined) {
            response = await req.send(dataJsonString);
        } else {
            response = await req.send();
        }
        if (response.header["x-token"]) {
            if (response.header["x-token"] !== ctx.csrfToken) {
                ctx.csrfToken = response.header["x-token"];
                localStorage.setItem('RpcClass.csrf', ctx.csrfToken);
            }
        }
        else if(response.body?.results?.csrfToken){
            ctx.csrfToken = response.body?.results?.csrfToken;
            localStorage.setItem('RpcClass.csrf', ctx.csrfToken);
        }

        if (pushCollector) {
            if(!response.body || response.body['hasExceptions']) {
                if(ctx.wsPipe){
                    ctx.wsPipe.fallbackPushReceived(false);
                }
            }else{
                if(ctx.wsPipe){
                    ctx.wsPipe.fallbackPushReceived(true);
                }
            }
        }

        return response;
    } catch (e){
        if (pushCollector) {
            if(ctx.wsPipe){
                ctx.wsPipe.fallbackPushReceived(false);
            }
        }
        throw e;
    }
}

const parseCookie = str =>
    str
        .split(';')
        .map(v => v.split('=', 2))
        .reduce((acc, v) => {
            if(v && v.length == 2) {
                acc[decodeURIComponent(v[0].trim())] = decodeURIComponent(v[1].trim());
            }
            return acc;
        }, {});

async function cordovaDoPost(callType, relativeUri, dataJson, ctx, p){
    
    if(!ctx){
        ctx = RpcClass;
    }
    let target = relativeUri;
    if(ctx.baseAddress){
                target = ctx.baseAddress + target;
    }

    if(callType === "post-multipart"){
                return RpcClass.cordovaDoPostMultipart(relativeUri, dataJson, ctx, target, p);
    }

    if(callType === 'post-json' && ctx.wsPipe && ctx.wsPipe && ctx.wsPipe.websocket.readyState === WebSocket.OPEN){
                return ctx.wsPipe.doPost(relativeUri, dataJson, ctx.csrfToken, target, p);
    }

    let headers = {
        "Content-Type": "application/json",
        "Accept": "application/json"
    }
    if(window.hasOwnProperty('_frontendBuildTag')){
        headers["x-build-tag"] = window['_frontendBuildTag'];
        headers["x-version"] = window['_frontendVersion'];
    }

    if(p['tag']){
        headers["x-tag"] = p['tag'];
    }
    if(ctx.csrfToken){
        headers["x-token"] = ctx.csrfToken;
    }
    let dataJsonString = JSON.stringify(dataJson);

                            
    let resPromise = new Promise((resolve, reject) => {
                cordova.plugin.http.setDataSerializer('utf8');
        cordova.plugin.http.post(
            target,
            dataJsonString,
            headers,
            function(response) {
                                resolve(response);
            }, function(response) {
                                resolve(response);
            });
    });

    p["req"] = resPromise;

    let pushCollector = false;
    if(ctx.userListensForEvents && ctx.wsPipe){
        let status = (ctx.wsPipe.websocket.readyState === WebSocket.OPEN ||
            ctx.wsPipe.websocket.readyState === WebSocket.CONNECTING);
        if(!status || !ctx.previousStatus){
            ctx.previousBroken = true;
            pushCollector = true;
                    }
        ctx.previousStatus = status;
    }
    //Client.interceptReq(req);
    try {
        
        let response = await resPromise;
        
        response.body = JSON.parse(response.data);

        
        if (response.headers["x-token"]) {
            if (response.headers["x-token"] !== ctx.csrfToken) {
                ctx.csrfToken = response.headers["x-token"];
                localStorage.setItem('RpcClass.csrf', ctx.csrfToken);
            }
        }
        let cookie = response.headers["set-cookie"];
        if(cookie){
            let parsed = parseCookie(cookie);
            if(parsed['sess']) {
                RpcClass.sessionCookie = parsed['sess'];
            }
        }

        if (pushCollector) {
            if(!response.body || response.body['hasExceptions']) {
                if(ctx.wsPipe){
                    ctx.wsPipe.fallbackPushReceived(false);
                }
            }else{
                if(ctx.wsPipe){
                    ctx.wsPipe.fallbackPushReceived(true);
                }
            }
        }

        return response;
    } catch (e){
        console.error(e);
        if (pushCollector) {
            if(ctx.wsPipe){
                ctx.wsPipe.fallbackPushReceived(false);
            }
        }
        throw e;
    }
}


RpcClass.isConvertedType = function(propType) {
        if(propType === "java.math.BigDecimal"){
                return true;
        }
        if(propType === "com.silkplm.engine.files.UploadedFile"){
                return true;
        }
        if(propType === "java.util.Date"){
                return true;
        }
        if(propType === "java.time.LocalDate"){
                return true;
        }
        if(propType === "java.time.LocalTime"){
                return true;
        }
        if(propType === "java.time.LocalDateTime"){
                return true;
        }
        if(propType === "com.silkplm.engine.files.UploadedFile[]"){
                return true;
        }
        if(propType === "java.time.Instant"){
                return true;
        }
        if(propType === "com.fasterxml.jackson.databind.node.ObjectNode"){
                return true;
        }

    return false;
}

RpcClass.makeFieldInstance = function(rawValue, propType){
    let v = rawValue;
    if(rawValue == null){
        return null;
    }
    if(propType === "java.math.BigDecimal"){
        v = new BigDecimal(rawValue)
    }
    if(propType === "com.silkplm.engine.files.UploadedFile"){
        v = null
    }
    if(propType === "java.util.Date"){
        v = new Date(rawValue)
    }
    if(propType === "java.time.LocalDate"){
        v = new LocalDate(); v.value = rawValue;
    }
    if(propType === "java.time.LocalTime"){
        v = new LocalTime(); v.value = rawValue;
    }
    if(propType === "java.time.LocalDateTime"){
        v = new LocalDateTime(); v.value = rawValue;
    }
    if(propType === "com.silkplm.engine.files.UploadedFile[]"){
        v = null
    }
    if(propType === "java.time.Instant"){
        v = new Date(rawValue)
    }
    if(propType === "com.fasterxml.jackson.databind.node.ObjectNode"){
        v = rawValue
    }

    return v;
}

RpcClass.injectPrototypes = function(obj){
    if(obj == null || typeof obj !== "object"){
        return;
    }
    if(obj.viewRowsMetadata){
        obj.viewRows.__rs_metadata__ = obj.viewRowsMetadata;
    }
    let elementMeta;
    let keys = Object.keys(obj);
    if(_.isArray(obj) && obj.__rs_metadata__){
        elementMeta = obj.__rs_metadata__;
        delete obj['__rs_metadata__'];
    }
    for(let i=0; i<keys.length; i++){
        let k = keys[i];
        let prop = obj[k];

        if(k.endsWith("__t")){
            continue;
        }
        if(k === "__rs_metadata__"){
            continue;
        }

        if(prop) {
            RpcClass.injectPrototypes(prop);
            let typeName = null;
            if(obj.hasOwnProperty(k + "__t") && !prop.hasOwnProperty("__typename__")){
                typeName = obj[k + "__t"];
            } else if(prop.hasOwnProperty("__typename__")){
                typeName = prop["__typename__"];
            }
            let isDynamic = false;
            let elemMeta = elementMeta ?? prop.__metadata__;
            if(elemMeta?.__dynamic__){
                typeName = elemMeta.__type__;
                isDynamic = true;
            }

            if(typeName) {
                if(RpcClass.isConvertedType(typeName)){
                    obj[k] = RpcClass.makeFieldInstance(prop, typeName);
                } else if (isDynamic){
                    let newProp = window['FormsLoader'].makeInstance(typeName, prop, elementMeta);
                    obj[k] = newProp;
                    prop = newProp;
                } else if(classMap.hasOwnProperty(typeName)) {
                    let proto = classMap[typeName].prototype;
                    let newProp = Object.create(proto);
                    let propKeys = Object.keys(prop);

                    for (let j = 0; j < propKeys.length; j++) {
                        let pk = propKeys[j];
                        if(!pk.startsWith("__")){
                            let rawValue = prop[pk];
                            if(!proto.__metadata__.hasOwnProperty(pk)){
                                if(!warnedMissingTypes[pk + " in " + typeName]) {
                                    Log.warn("missing metadata for: " + pk + " in " + typeName);
                                    warnedMissingTypes[pk + " in " + typeName] = 1;
                                }
                                newProp[pk] = prop[pk]
                            } else if(!proto.__metadata__[pk]){
                                if(!warnedMissingTypes[pk + " in " + typeName]) {
                                    Log.warn("missing metadata[2] for: " + pk + " in " + typeName);
                                    warnedMissingTypes[pk + " in " + typeName] = 1;
                                }
                                newProp[pk] = prop[pk]
                            } else {
                                let propType = proto.__metadata__[pk].remoteType;
                                newProp[pk] = RpcClass.makeFieldInstance(rawValue, propType);
                            }
                        } else {
                            newProp[pk] = prop[pk];
                        }
                    }
                    prop = newProp;
                    obj[k] = newProp;
                } else {
                    delete prop["__typename__"];
                }
            }
        }
    }
}


RpcClass.decrease = function(){
    if(RpcClass.requestsStatus.counter === undefined){
        RpcClass.requestsStatus.counter = 0;
    } else {
        RpcClass.requestsStatus.counter--;
        if(RpcClass.requestsStatus.counter < 0){
            RpcClass.requestsStatus.counter = 0;
        }
    }
    if(RpcClass.requestsStatus.counter === 0){
        EventBus.$emit(Events.rpcEnd);
    }
}

RpcClass.increase = function(){
    if(RpcClass.requestsStatus.counter === 0){
        EventBus.$emit(Events.rpcStart);
    }

    if(RpcClass.requestsStatus.counter === undefined){
        RpcClass.requestsStatus.counter = 1;
    } else {
        RpcClass.requestsStatus.counter++;
    }
}

/**
 * @param methodPath {string}
 * @param parameters {[Object]}
 * @returns {ExtendedPromise}
 */
RpcClass.rpcCallMultipart = function(methodPath, parameters){
    RpcClass.increase();
    let pRef = {};
    let p = new Promise((resolve, reject)=>{
        setTimeout(() => {
           RpcClass.rpcCallCommon('post-multipart', methodPath, parameters, pRef).then((data) => {
               data = DelayedTaskManager?.captureDelayedTask(data);
               resolve(data);
           }).catch((err) => reject(err)).finally(() => RpcClass.decrease());
           if(pRef.hasOwnProperty("onProgress")){
               pRef["req"].on("progress", pRef["onProgress"]);
           }
        });
    });
    p.onProgress = function(callback){
        if(pRef.hasOwnProperty("req")){
            pRef["req"].on("progress", callback);
        }
        else{
            pRef["onProgress"] = callback;

        }
        return p;
    }
    p.lock = function(){
        Client.lockDuringNextRequest();
        return p;
    }
    p.tag = function(sourceTag){
        pRef["tag"] = sourceTag;
        return p;
    }
    return p;
}


/**
 * @param methodPath {string}
 * @param parameters {[Object]}
 * @returns {ExtendedPromise}
 */
RpcClass.rpcCall = function(methodPath, parameters) {
    RpcClass.increase();
    let pRef = {};
    let p = new Promise((resolve, reject)=>{
        setTimeout(() => {
                RpcClass.rpcCallCommon('post-json', methodPath, parameters, pRef).then((data) => {
                data = DelayedTaskManager?.captureDelayedTask(data);
                resolve(data);
            }).catch((err) => reject(err)).finally(() => RpcClass.decrease());
        });
    });
    p.onProgress = function(callback){
        pRef["req"].on("progress", callback);
        return p;
    }
    p.lock = function(){
        Client.lockDuringNextRequest();
        return p;
    }
    p.tag = function(sourceTag){
        pRef["tag"] = sourceTag;
        return p;
    }
    return p;
}


/**
 * @param methodPath {string}
 * @param parameters {[Object]}
 * @returns {ExtendedPromise}
 */
RpcClass.rpcCallFixed = function(methodPath, parameters) {
    RpcClass.increase();
    let pRef = {};
    let p = new Promise((resolve, reject)=>{
        setTimeout(() => {
            RpcClass.rpcCallCommon('post-json-fixed', methodPath, parameters, pRef).then((data) => {
                data = DelayedTaskManager?.captureDelayedTask(data);
                resolve(data);
            }).catch((err) => reject(err)).finally(() => RpcClass.decrease());
        });
    });
    p.onProgress = function(callback){
        pRef["req"].on("progress", callback);
        return p;
    }
    p.lock = function(){
        Client.lockDuringNextRequest();
        return p;
    }
    p.tag = function(sourceTag){
        pRef["tag"] = sourceTag;
        return p;
    }
    return p;
}

/**
 * @param methodPath {string}
 * @param parameters {[Object]}
 * @param p {*}
 * @returns {Promise}
 */
RpcClass.rpcCallCommon = async function(callType, methodPath, parameters, p){
        let start = performance.now();
        let response;
        let retry = 5;


        let ctx = RpcClass;
        if(RpcClass.savedContext) {
            ctx = RpcClass.saveRpcContext();
            RpcClass.restoreRpcContext(RpcClass.savedContext);
        }

        while (true) {
            try {
                let raw = (await this.doPost(callType, methodPath, parameters, ctx, p));
                response = raw.body;
                if (RpcClass.rebootCaptured) {
                    RpcClass.EventBus.$emit(Events.serverActive);
                    RpcClass.rebootCaptured = false;
                }
                if(RpcClass.shouldWait(response)){
                    Log.info("Request throttled:" + methodPath);
                    await new Promise((resolve, reject) => setTimeout(() => {
                        resolve();
                    }, 6100));
                    continue;
                }
                break;

            } catch (e) {
                if (e.status === undefined) {
                    throw e;
                }
                let status = "%c ✕";
                let css = "color: #a02020";
                if (e.status == 500) {
                    status = "%c 500 ✕";
                    Log.warning("Failed RPC call:" + methodPath + status, {css: [css]});
                    throw new RpcServerInternalException(e);
                }
                if (e.status == 403) {
                    status = "%c 403 ✕";
                    Log.warning("Forbidden RPC call:" + methodPath + status, {css: [css]});
                    throw new RpcUnauthorizedException(e);
                }
                if (e.status >= 400 && e.status < 500) {
                    status = "%c 4xx ✕";
                    Log.warning("Forbidden RPC call:" + methodPath + status, {css: [css]});
                    throw new RpcNotFoundException(e);
                }

                if (e.status == 503) {
                    if (!RpcClass.rebootCaptured) {
                        RpcClass.rebootCaptured = true;
                        RpcClass.EventBus.$emit(Events.serverRebooting);
                    }
                }

                retry--;
                if (retry == 0) {
                    Log.warning("Failed RPC call:" + methodPath + status, {css: [css]});
                    RpcClass.EventBus.$emit(Events.serverBroken);
                    throw new RpcClientInternalException({...e});
                }

                await new Promise((resolve, reject) => setTimeout(() => {
                    resolve();
                }, 6000));
            }
        }
        if (response.hasOwnProperty("requestToken")) {
            let css = "";
            let status = "";
            if (!response.hasExceptions) {
                status = "%c ✓";
                css = "color: #208020";
            } else {
                status = "%c ✕";
                css = "color: #a02020";
            }
            let stop = performance.now();
            let tm = Math.round(stop - start);

            let msg = response.requestToken + "(" + (tm) + "ms) " + status;
            let options = {
                css: [css], details: [
                    " " + moment().format("HH:mm:ss") + "," +
                    " hasResults: " + response.hasResults + ", " + " hasExceptions: " + response.hasExceptions,
                    " parse: " + response.parseTime / 1000 + "ms, " +
                    " validation: " + response.validationTime / 1000 + "ms, " +
                    " lookup: " + response.lookupTime / 1000 + "ms, " +
                    " execution: " + response.executionTime / 1000 + "ms"
                ]
            };
            if(!response.hasExceptions && RpcClass.logSuccessful) {
                Log.info(msg, options);
            }
            if(response.hasExceptions){
                Log.warning(msg, options);
            }
        }

        if (response['pushEvents'] && response['pushEvents'].length > 0) {
            if (!classMap) {
                await getClassMap();
            }
            try {
                await RpcClass.dispatchPush(response['pushEvents'], response['tag']);
            } catch (e) {
                Log.warn(e);
            }
        }

        if (response['hasResults']) {
            if (!classMap) {
                await getClassMap();
            }
            let rsMetadata = response.resultSetMetadata;
            if(rsMetadata){
                if(_.isArray(response.results)){
                    response.results.__rs_metadata__ = rsMetadata;
                }
            }
            let res = {"results": response.results};
            RpcClass.injectPrototypes(res);

            if (response.resultFlags && response.results instanceof Object) {
                Object.defineProperty(res.results, '__flags', {
                    value: response.resultFlags,
                    enumerable: false,
                    writable: true,
                    configurable: true
                });
            }
            return res.results;
        }

        if (response['hasExceptions']) {
            RpcClass.decodeException(response['exceptions'][0]);
        }
        return undefined;

}

/**
 * @param pushData
 * @param tag {string}
 * @return {Promise<void>}
 */
RpcClass.dispatchPush = async function(pushData, tag){
    if (!classMap) {
        await getClassMap();
    }
    let res = {"pushEvents" : pushData};
    if(!(pushData instanceof Array)) {
        pushData = [pushData];
    }
    RpcClass.injectPrototypes(res);
    try{
        for(let i=0; i<pushData.length; i++) {
            let ev = pushData[i];
            let messageCode = ev.type.split(".").splice(-1)[0];
            messageCode = "srv-" + messageCode.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();

            if (RpcClass.lastPushTimestamp < ev.timestamp) {
                RpcClass.lastPushTimestamp = ev.timestamp;
            }

            let uid = ev.uid + "#" + ev.timestamp + "#" + messageCode;
            if (RpcClass.deduplicationSet.has(uid)) {
                Log.info("Event from server de-duplicated: %c" + messageCode, {css: ["color: #208020"]});
                return;
            }
            RpcClass.deduplicationSet.add(uid)
            let toRemove = RpcClass.deduplicationSet.size - deduplicationLimit;
            if (toRemove > 0) {
                for (let item of RpcClass.deduplicationSet) {
                    RpcClass.deduplicationSet.delete(item);
                    toRemove--;
                    if (toRemove == 0) {
                        break;
                    }
                }
            }
            if(window.hasOwnProperty('SessionManager')){

                if(tag?.startsWith(SessionManager.publicSessionId)){
                    ev.tag = tag.substr(SessionManager.publicSessionId.length + 1);
                } else {
                    ev.tag = tag;
                }
            }
            RpcClass.EventBus.$emit(messageCode, ev);
            Log.info("Event from server pushed: %c" + messageCode, {css: ["color: #208020"]});
        }
    } catch (e) {
        Log.warn(e);
    }
}

RpcClass.shouldWait = function(response){
    if (response['hasExceptions']) {
        let exception = response['exceptions'][0];
        if(exception.exceptionClassName.match(/.*\/rpc\/exceptions\/RpcMustWaitException/)){
            return true;
        }
    }
    return false;
}

/**
 * @param exception
 * @returns *
 */
RpcClass.decodeException = function(exception){
    if(exception.exceptionClassName === "com/silkplm/engine/rpc/exceptions/RpcLimitsExceeded"){
        RpcClass.EventBus.$emit("rpc-limits-exceeded", exception);
    }

    if(exception.exceptionClassName.match(/.*\/rpc\/exceptions\/RpcInputValidationException/)){
        console.log("Validation input failed");
        console.table(exception.fields, ['isValid', 'errorMessage']);
    } else{
        Log.fatal(exception.exceptionClassName + ": " + exception.message);
    }

    let ex = null;
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcClientInternalException'){
        ex = new RpcClientInternalException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcException'){
        ex = new RpcException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcInputException'){
        ex = new RpcInputException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcInputValidationException'){
        ex = new RpcInputValidationException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcInternalException'){
        ex = new RpcInternalException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcLimitsExceeded'){
        ex = new RpcLimitsExceeded(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcLoginRequired'){
        ex = new RpcLoginRequired(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcNoPermissionsException'){
        ex = new RpcNoPermissionsException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcNotFoundException'){
        ex = new RpcNotFoundException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcServerInternalException'){
        ex = new RpcServerInternalException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/engine/rpc/exceptions/RpcUnauthorizedException'){
        ex = new RpcUnauthorizedException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/RpcMustWaitException'){
        ex = new RpcMustWaitException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/FileImportException'){
        ex = new FileImportException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/InvalidTaxIDException'){
        ex = new InvalidTaxIDException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/LastOwnerCannotBeDeletedException'){
        ex = new LastOwnerCannotBeDeletedException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/NoOwnerException'){
        ex = new NoOwnerException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/OrganizationDeletedException'){
        ex = new OrganizationDeletedException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/RelatedRecordsException'){
        ex = new RelatedRecordsException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/RoleIsAssignedException'){
        ex = new RoleIsAssignedException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/RoleIsNotAvailableException'){
        ex = new RoleIsNotAvailableException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/TaskBrakeException'){
        ex = new TaskBrakeException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/TooManyUsersException'){
        ex = new TooManyUsersException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/exceptions/UserCannotBeDeletedException'){
        ex = new UserCannotBeDeletedException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/healthcheck/RpcFruitsException'){
        ex = new RpcFruitsException(exception);
    }
    if(exception.exceptionClassName === 'com/silkplm/rpc/healthcheck/methods/BusinessException'){
        ex = new BusinessException(exception);
    }
    if(!ex){
        ex = new RpcClientInternalException({...exception, 'message': "Unknown exception: " + exception});
    }
    RpcClass.EventBus.$emit("rpc-exception", ex);
    throw ex;
}


RpcClass.extendPromise = extendPromise;
window.RpcClass = RpcClass;
export default RpcClass;